/* eslint-disable */
<template>
  <div class="manage-booking">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel no-sub-title">
      <Header />
      <div v-if="showContent" class="header-title-section">
        <div class="header-title d-flex">
          <h1>Booking {{ booking.BookingID }} on Case {{ booking.CaseID }} for {{decodeURIComponent(booking.Case.ClaimantFullName)}}</h1>
          <img v-if="booking.VideoLink" class="ml-4" src="@/assets/images/video_black_icon.svg" />
        </div>
      </div>
      <div v-else class="header-title-section"><h5>Invalid Booking Information</h5></div>
    </div>
    <div class="panel no-sub-title">
      <AdminBookingsMenu :key="statusKey" :indexProps="isCancelled ? 7 : 0" />
      <div class="content" v-if="showContent">
        <div class="box case-container remove-min-height">
          <div class="box-heading tab d-flex align-items-center is-icon" @click="toggleBoxDisplay()">
            <img src="@/assets/images/case_dark_icon.svg" class="ml-2" height="50px" />
            <span class="mr-4">Examinee: {{booking.Salutation}} {{ decodeURIComponent(singleCase.ClaimantFullName) }}</span>
            <span class="mr-4">Client: {{ decodeURIComponent(client.ClientName ? `${client.ClientName} - ${client.BranchName}` : '')}}</span>
            <span class="mr-4">
              <span v-if="singleCase.ClaimantFullName" class="mr-2">{{ decodeURIComponent(singleCase.ClaimantFullName) }}</span>
              <span v-if="singleCase.ClaimantPhone1" class="mr-2"><b>P: </b>{{ singleCase.ClaimantPhone1 }}</span>
              <span v-if="singleCase.ClaimantMobile" class="mr-2"><b>M: </b>{{ singleCase.ClaimantMobile }}</span>
              <span v-if="singleCase.ClaimantPhone2" class="mr-2"><b>P: </b>{{ singleCase.ClaimantPhone2 }}</span>
              <span v-if="singleCase.ClaimantEmail" class="mr-2"><b>E: </b>{{ decodeURIComponent(singleCase.ClaimantEmail) }}</span>
            </span>
            <img src="@/assets/images/view_booking.svg" class="right-element is-icon" @click.stop="goToCase(booking.CaseID)" />
          </div>
          <div class="box-body hidden-element">
            <div class="box-row">
              <div class="box-col box-col-left">Status</div>
              <div class="box-col box-col-right">
                <span class="">{{singleCase.CaseStatus === '0' ? 'Inactive' : 'Active'}}</span>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Case Details</div>
              <div class="box-col box-col-right d-flex justify-content-between align-items-center">
                D.O.B: {{ formatDate(singleCase.DateofBirth, "DD/MM/YYYY", "YYYY-MM-DD") }}
                <span class="me-10">Case Name: {{ singleCase.CaseName }}</span>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Examinee Details</div>
              <div class="box-col box-col-right">
                <span v-if="singleCase.PreferredGivenName" class="mr-3"><b>Preferred Name: </b><span> {{ decodeURIComponent(singleCase.PreferredGivenName) }}</span></span>
                <span v-if="singleCase.ClaimantPhone1" class="mr-3"><b>Ph: </b><u class="is-icon" @click="openEmailModal('claimant', 1)">{{ singleCase.ClaimantPhone1 }}</u></span>
                <span v-if="singleCase.ClaimantMobile" class="mr-3"><b>M: </b><u class="is-icon" @click="openEmailModal('claimant', 1)">{{ singleCase.ClaimantMobile }}</u></span>
                <span v-if="singleCase.ClaimantPhone2" class="mr-3"><b>Ph: </b><u class="is-icon" @click="openEmailModal('claimant', 1)">{{ singleCase.ClaimantPhone2 }}</u></span>
                <span v-if="singleCase.ClaimantEmail" class="mr-3"><b>E: </b><u class="is-icon" @click="openEmailModal('claimant', 0)">{{ decodeURIComponent(singleCase.ClaimantEmail) }}</u></span>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Examinee Address</div>
              <div class="box-col box-col-right">{{ formattedAddress }}</div>
            </div>
          </div>
        </div>

        <div class="content-sub-content">
        <div class="row m-0 p-0">
          <div class="col-9 m-0 p-0">
            <div class="box">
              <div class="box-heading d-flex align-items-center">
                Booking Details
                <div class="right-element d-flex align-items-center">
                  <div v-if="booking.OriginalBookingID" class="mr-5"><router-link class="ml-14" :to="{ name: 'admin-manage-booking', query: { id: booking.OriginalBookingID } }"><v-btn dark>{{booking.OriginalBookingID}}</v-btn></router-link></div>
                  <img @click="toEditPage" class="mt-1 mr-4 is-icon small-icon" src="@/assets/images/chat_icon_edit.svg" />
                  <img @click="openPreEmailModal()" class="mt-1 mr-2 is-icon small-icon" src="@/assets/images/chat_Icon_circle.svg" />
                  <a :href="booking.ZohoLink" target="blank"><img src="@/assets/images/zoho_circle.svg" class="ml-2 mr-2 is-icon" /></a>
                  <!-- Removed private option from the booking -->
                  <!-- <div v-if="booking.private" class="ml-2 mr-2 is-icon" style="background: white; width: 40px; height: 40px; border-radius: 50%; border-radius: 50%; justify-content: center; display: flex;">
                    <img v-if="booking.private" src="@/assets/images/eye-private.svg" style="width: 20px;" />
                  </div> -->
                </div>
              </div>
              <div class="box-row disabled-element" v-if="showOriginalClientContact">
                <div class="box-col box-col-left left-label">Original Client Contact</div>
                <div class="box-col box-col-right align-items-center d-flex">
                  {{ originalClientContactDisplay }} ({{booking.OriginalClientContactID}})
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left left-label required">Client Contact</div>
                <div class="box-col box-col-right align-items-center d-flex">
                  <div class="d-flex align-items-center w-100 flex-wrap">
                    <el-select :disabled="booking.Status.StatusID === 6" placeholder="Select New Contact" class="w-50" :class="hasError && clientContactError ? 'is-invalid' : ''" v-model="booking.ClientContactID" filterable>
                      <el-option v-for="item in contacts" :value="item.id" :key="item.id" :label="item.name">{{item.name}}</el-option>
                    </el-select>
                    <span class="ml-2" v-html="getContactInfo()"></span>
                    <div v-if="hasError && clientContactError" class="text-danger w-100 mt-1">{{ clientContactError }}</div>
                  </div>
                </div>
              </div>
              <div class="box-body d-block" v-if="booking.BookingID">
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Service Type</div>
                  <div class="box-col box-col-right box-center">
                    <el-select v-model="booking.BookingTypeID" class="w-50" @change="changeBookingType()"
                      :disabled="isDisabled || booking.Status.StatusID === 6 || disableBookingType">
                      <el-option :value="type.id" :key="type.id" v-for="type in bookingTypes" :label="type.name">{{ type.name }}</el-option>
                    </el-select>
                    <v-btn class="ml-4" :class="ShowVideoLinkUrl ? 'reverse-btn' : ''" small @click="switchShowLink" v-if="booking.BookingTypeID === 7" dark>{{ShowVideoLinkUrl ? 'Change to Phone Call' : 'Change to VideoLink Call'}}</v-btn>
                  </div>
                </div>
                <div class="box-row" v-if="booking.AvailabilityID && showDelivery">
                  <div class="box-col box-col-left left-label required">Delivery Method</div>
                  <div class="box-col box-col-right box-center">
                    <el-select :disabled="booking.Status.StatusID >= 5" v-model="booking.DeliveryMethodID" class="  w-75" :class="hasError && deliveryMethodError ? 'is-invalid' : ''" >
                      <el-option :disabled="booking.Status.StatusID !== 6 && booking.Availability.DeliveryMethods.filter(item => item.DeliveryMethodID === 2).length === 0" :value="2" label="Virtual"
                                 title="This service will be delivered by videolink only."></el-option>
                      <el-option :disabled="booking.Status.StatusID !== 6 && booking.Availability.DeliveryMethods.filter(item => item.DeliveryMethodID === 1).length === 0" :value="1" label="In-Person"
                                 title="This service will be delivered face to face with the Medical Expert"></el-option>
                    </el-select>
                    <div v-if="hasError && deliveryMethodError" class="text-danger pl-2">{{ deliveryMethodError }}</div>
                  </div>
                </div>
                <div class="box-row" v-if="booking.BookingTypeID === 19" >
                  <div class="box-col box-col-left left-label required">Number of services</div>
                  <div class="box-col box-col-right">
                    <el-checkbox v-model="showMAS" @change="onChangeNum('MAS', $event)" class="default-checkbox tick">MAS</el-checkbox> <el-input-number v-show="showMAS" :controls="false" style="width: 50px" v-model="booking.MAS" controls-position="right" :min="0" step-strictly :max="10"></el-input-number>
                    <el-checkbox v-model="showPIC" @change="onChangeNum('PIC', $event)" class="default-checkbox tick">PIC</el-checkbox> <el-input-number v-show="showPIC" :controls="false" style="width: 50px"  v-model="booking.PIC" controls-position="right" :min="0" step-strictly :max="10"></el-input-number>
                    <el-checkbox v-model="showSHORT" @change="onChangeNum('ShortReport', $event)" class="default-checkbox tick">Short Report</el-checkbox> <el-input-number v-show="showSHORT" :controls="false" style="width: 50px"  v-model="booking.ShortReport" controls-position="right" step-strictly :min="0" :max="10"></el-input-number>
                    <div v-if="hasError && numOfServicesError" class="text-danger pl-2">{{ numOfServicesError }}</div>
                  </div>
                </div>
                <div v-if="(booking.DeliveryMethodID === 2 && booking.BookingTypeID !== 7) || (ShowVideoLinkUrl && booking.BookingTypeID === 7)" class="box-row disabled-element">
                  <div class="box-col box-col-left left-label d">Video Link URL</div>
                  <div class="box-col box-col-right">
                    <el-input :disabled="true" type="text" maxlength="255" class="video-link-url  w-75" v-model="booking.VideoLinkURL" placeholder="Video Link URL" />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Booking Status</div>
                  <div v-if="booking.BookingStatus !== '6' && (booking.BookingStatus !== '7' || user.type >= 6)" class="box-col box-col-right box-center">
                    <el-select v-model="booking.Status.StatusID" @change="changeBookingStatusName()" class="w-75">
                      <el-option v-for="bookingStatus in bookingStatuses" :value="bookingStatus.id" :label="bookingStatus.name" :key="bookingStatus.id">{{ bookingStatus.name }}</el-option>
                    </el-select>
                    <div class="ml-2">
                      {{booking.BookingTrackingStatus}}
                    </div>
                  </div>
                  <div v-else class="box-col box-col-right box-center px-8 w-75">{{booking.Status.StatusDescription}}</div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Specialist</div>
                  <div class="box-col box-col-right d-flex justify-content-between align-items-center">
                    <div class="mr-2">{{getSpecialistFullNameUpper()}}</div>
                    <el-tooltip  effect="dark" :content="curSpecialty" placement="bottom">
                    <span style="white-space: nowrap; display: block;  overflow: hidden;text-overflow: ellipsis; flex: 1">{{ curSpecialty }}</span>
                    </el-tooltip>
                    <router-link v-if="bookingDate && !isTPD" style="margin: unset" class="mr-2 ml-2" :to="{ name: 'admin-availability-bookings', query: { id: booking.Specialist.SpecialistID, date: bookingDate } }"
                      ><img src="@/assets/images/calendar_black_icon.svg"
                    /></router-link>
                  </div>
                </div>
                <div class="box-row" v-if="isShowForBooking && booking.Location">
                  <div class="box-col box-col-left left-label">Location</div>
                  <div class="box-col box-col-right" style="display: flex;align-items: center;">
                    <div>{{getLocationNameWithCoutry(booking.Location.LocationID || '')}}</div>
                    <router-link v-if="user.type === 6" class="ml-14" :to="{ name: 'admin-manage-location', query: { locationId: booking.Location.LocationID || ''} }"><img src="@/assets/images/view_booking.svg"/></router-link>
                  </div>
                </div>
                <div v-if="booking.DeliveryMethodID === 2 && showDelivery" class="box-row">
                  <div class="box-col box-col-left left-label">Examinee Location for VideoLink</div>
                  <div class="box-col box-col-right">
                    <el-input :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"  type="text" class=" w-75" maxlength="255" v-model="booking.ClaimantLocation" placeholder="Examinee Location for VideoLink" />
                    <div v-if="hasError && examineeLocationError" class="text-danger pl-2">{{ examineeLocationError }}</div>
                  </div>
                </div>
                <div v-if="booking.DeliveryMethodID === 2 && !isTPD" class="box-row">
                  <div class="box-col box-col-left left-label required">{{booking.BookingTypeID === 7 ? 'Client State for Phone Call' : 'Examinee State During Booking'}}</div>
                  <div class="box-col box-col-right">
                    <el-cascader
                        popper-class="search-no-scroll-panel"
                        :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"
                        clearable
                        v-model="bookingExamineeStatus"
                        @change="changeState"
                        :options="states"
                        :class="hasError && examineeStateError ? 'is-invalid' : ''"
                        placeholder="Please select"></el-cascader>
                    <span v-if="timeZoneValue" class="ml-2">{{timeZoneValue}}</span>
                    <span class="pl-4 left-label">Booking Time in Examinee State</span>
                    <span type="text" class="w-35 ml-4">{{formatDate(booking.ClaimantBookingDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss")}}</span>
                    <div v-if="hasError && examineeStateError" class="text-danger pl-2">{{ examineeStateError }}</div>
                  </div>
                </div>
                <div class="box-row" v-if="isShowForBooking">
                  <div class="box-col box-col-left left-label">Date & Time</div>
                  <div class="box-col box-col-right" :key="timeKey">
                    <!-- <input type="text" v-model="bookingDateTimeComputed" /> -->
                    <datepicker disabled v-model="bookingDate" format="dd/MM/yyyy" :typeable="true" class="w-35" placeholder="dd/mm/yyyy"></datepicker>
                    <!-- <vue-timepicker v-if="!showTime" :disabled="showTime ? false : true" tabindex="14" format="hh:mm A" v-model="bookingTime" input-class="form-control w-50 border-0" class="w-50" placeholder="Appointment Time" :minute-interval="5" /> -->
                    <span type="text" class="w-35 ml-4">{{bookingTime}}</span>
                    <s class="ml-15 text-decoration-none">Length: {{ calculateBookingDuration(formatDate(booking.BookingDateTime, "YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"),formatDate(booking.BookingDateTime, "hh:mm A", "YYYY-MM-DD HH:mm:ss"),formatDate(booking.BookingEndTime, "hh:mm A", "HH:mm:ss"))}} minutes</s>
                    <div v-if="hasError && bookingTimeError" class="text-danger w-100 mt-1">{{ bookingTimeError }}</div>
                  </div>
                </div>
                <div class="box-row" v-if="booking.Reassessment">
                  <div class="box-col box-col-left left-label">Re-assessment</div>
                  <div class="box-col box-col-right box-col-center">
                    <input type="checkbox" :checked="!!booking.Reassessment" :disabled="booking.Reassessment"  />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label required">Client Reference Number</div>
                  <div class="box-col box-col-right">
                    <input :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7" class="textbox" type="text" placeholder="Client reference number" maxlength="40" :class="hasError && clientReferenceError ? 'is-invalid' : ''" v-model="booking.ClientReference"/>
                    <div v-if="hasError && clientReferenceError" class="text-danger">{{ clientReferenceError }}</div>
                  </div>
                </div>
                <div class="box-row" v-if="booking.BookingTypeID === 8" >
                  <div class="box-col box-col-left left-label">Future Date this Supp</div>
                  <div class="box-col box-col-right box-col-center">
                    <el-date-picker
                        popper-class="date-range-picker-popper"
                        type="datetime"
                        clearable
                        :picker-options="pickerOptions"
                        editable
                        class="w-50"
                        v-model="booking.SuppFutureDate"
                        format="dd/MM/yyyy HH:mm"
                        placeholder="dd/mm/yyyy"></el-date-picker>
                  </div>
                </div>
                <div class="box-row" >
                  <div  class="box-col box-col-left left-label required">State where the incident occurred</div>
                  <div class="box-col box-col-right">
                    <el-select v-model="booking.IncidentState" :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7" :class="hasError && incidentStateError ? 'is-invalid' : ''">
                      <el-option v-for="state in statesNew" :key="state.value" :value="state.value" :label="state.text">{{ state.text }}</el-option>
                    </el-select>
                    <div v-if="hasError && incidentStateError" class="text-danger">{{ incidentStateError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label required">Referral Type</div>
                  <div class="box-col box-col-right">
                    <el-select v-model="booking.ClaimTypeID" class="w-75" :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7 || isTPD" :class="hasError && referralTypeError ? 'is-invalid' : ''">
                      <el-option v-for="claimType in claimTypes" :value="claimType.id" :key="claimType.id" :label="claimType.name">{{ claimType.name }}</el-option>
                    </el-select>
                    <div v-if="hasError && referralTypeError" class="text-danger pl-2">{{ referralTypeError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Booking Details</div>
                  <div class="box-col box-col-right d-flex align-items-center">
                    <img
                      class="ml-2 is-icon"
                      src="@/assets/images/claimant_attendance_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getAttendanceTitle"
                      :data-original-title="getAttendanceTitle"
                      @click="toggleAttendance()"
                      :class="isDate(booking.ClaimantConfirmed) || booking.ClaimantConfirmed ? '' : 'disabled-element'"
                    />
                    <img
                      class="ml-2 is-icon"
                      src="@/assets/images/can_ring_claimant_icon.svg"
                      style="padding-left: 6px;"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getCanRingClaimantTitle"
                      :data-original-title="getCanRingClaimantTitle"
                      @click="toggleCanRingClaimant()"
                      :class="booking.RedHealthMayContactClaimant ? '' : 'disabled-element'"
                    />
                    <img
                      class="ml-2 is-icon"
                      src="@/assets/images/consent_received_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getConsentReceivedTitle"
                      :data-original-title="getConsentReceivedTitle"
                      @click="toggleConsentReceived()"
                      :class="isDate(booking.ClaimantConsentReceived) || booking.ClaimantConsentReceived ? '' : 'disabled-element'"
                    />
                    <img
                      class="is-icon"
                      src="@/assets/images/call_after_appointment_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      style="padding-left: 6px;"
                      :title="getCallAfterAppointmentTitle"
                      :data-original-title="getCallAfterAppointmentTitle"
                      @click="toggleCallAfterAppointment()"
                      :class="booking.CallClientAfterAppointment ? '' : 'disabled-element'"
                    />
                    <img
                      v-if="booking.DeliveryMethodID === 2"
                      class="ml-2 is-icon"
                      src="@/assets/images/video_link_test_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      style="padding-left: 6px;"
                      :title="getHasVideoTitle"
                      :data-original-title="getHasVideoTitle"
                      @click="toggleHasVideo()"
                      :class="booking.VideoLinkTestStatus == 2 ? '' : 'disabled-element'"
                    />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Acting on behalf of</div>
                  <div class="box-col box-col-right">
                    <el-select :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7" v-model="booking.OnBehalfOf" class="w-100" placeholder="Acting on behalf of" filterable clearable>
                      <el-option v-for="item in clients" :key="item.id" :value="item.fullName" :label="decodeURIComponent(item.fullName)"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="box-row">
                  <div class="box-col box-col-left left-label">Date of Accident/Event</div>
                  <div class="box-col box-col-right box-col-center">
                    <div class="w-72">
                      <div class="right-float-element" style="line-height: 40px;">
                        <toggle-button :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"  @change="changeOverTime()" class="togglePeriodOfTime" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="!!booking.OverPeriodofTime"/>  Over a period of time
                      </div>
                      <datepicker
                          :disabled="booking.OverPeriodofTime !== 0 || booking.Status.StatusID === 6"
                          format="dd/MM/yyyy"
                          :typeable="true"
                          class="w-50 accient-date"
                          placeholder="dd/mm/yyyy"
                          v-model="booking.AccidentDate"
                          @selected="selectAccientDate"
                          @input="changeAccientDate"></datepicker>
                    </div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Affected Body Areas</div>
                  <div class="box-col box-col-right box-col-center">
                    <vue-tags-input
                        :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"
                        class=" pr-7"
                      v-model="bodyAreaTag"
                      :tags="bodyAreaTags"
                      placeholder="Please choose"
                      @before-deleting-tag="deleteBodyArea"
                      @focus="openDigram" />
                    <div @click="openBodyDiagram">
                      <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3" style="top:50%;margin-top:-18px;"/>
                    </div>
                    <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal" />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Other Body Areas</div>
                  <div class="box-col box-col-right box-col-center">
                    <vue-tags-input
                        :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"
                        class=""
                      :maxlength="50"
                      v-model="otherBodyAreaTag"
                      :tags="otherBodyAreaTags"
                      placeholder="Add Other Body Areas"
                      @tags-changed="updateOtherBodyArea" />
                    <div v-if="hasError && otherBodyAreasError" class="text-danger w-100">{{ otherBodyAreasError }}</div>
                  </div>
                </div>
                <div class="box-row reset-line-height">
                  <div class="box-col box-col-left left-label">Conditions</div>
                  <div class="box-col box-col-right box-col-center">
                    <el-select placeholder="Add Conditions" class="w-100" :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7" v-model="booking.PersonConditions" multiple clearable filterable>
                      <el-option v-for="item in personConditions" :value="item.value" :label="item.text" :key="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="box-row" v-if="booking.BookingTypeID !== 19">
                  <div class="box-col box-col-left left-label">Interpreter Details</div>
                  <div class="box-col box-col-right d-flex align-items-center flex-wrap">
                    <div @click="openInterpreterDetail" :readonly="true" type="text" class="" maxlength="255" v-html="getInterpreterDetail()" placeholder="Click to add interpreter details if required" />
                    <el-checkbox :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7" class="ml-3" v-model="booking.OrganizeRequired" size="large" >Red Health to organize</el-checkbox>
                  </div>
                </div>
                <div class="box-row" v-if="booking.DeliveryMethodID === 2">
                  <div class="box-col box-col-left left-label">Surrogate Details</div>
                  <div class="box-col box-col-right">
                    <div @click="openSurrogateDetail" :readonly="true"  type="text" class="" maxlength="255" v-html="getSurrogateDetail()" placeholder="Click to add surrogate details if required" />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Paperwork Due</div>
                  <div class="box-col box-col-right" style="padding-left:20px; display: flex;flex-direction: row;align-items: center;">
                    <div class="w-72">
                      <datepicker
                        v-model="booking.PaperworkDue"
                        format="dd/MM/yyyy"
                        :disabled="true"
                        placeholder="dd/mm/yyyy"
                        :input-class="hasError && (paperworkDueError || !isValidPaperworkDue) ? 'is-invalid' : ''"
                        class="w-50 paperwork-due"
                        />
                      <div class="text-danger ml-2" v-if="hasError && (paperworkDueError || !isValidPaperworkDue)">
                        {{ paperworkDueError || 'Paperwork due is invalid.' }}
                      </div>
                    </div>
                    <!-- <select
                      v-model="booking.paperworkStatus"
                      class="w-35 ml-4 custom-arrow ">
                      <option value="" hidden>Please choose ...</option>
                      <option value="1">LOI Received</option>
                      <option value="2">Brief Received</option>
                      <option value="3">Paperwork Processed</option>
                      <option value="4">Pre-Appointment Forms Completed</option>
                    </select> -->
                    <div class="box-col box-col-right d-flex align-items-center">
                      Paperwork Processed?
                      <img
                        class="ml-6 is-icon cursor-pointer"
                        src="@/assets/images/paperwork-processed.svg"
                        data-toggle="tooltip"
                        data-placement="right"
                        style="height: 20px"
                        title="Paperwork Processed"
                        @click="togglelolPaperworkProcessed"
                        :class="isDate(booking.PaperworkProcessed) ? '' : 'disabled-element'"
                      />
                    </div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Send Report To</div>
                  <div class="box-col box-col-right">
                    <!-- <select class="w-75" v-model="booking.reportTo">
                      <option value="" hidden>Please choose ...</option>
                      <option :value="contact.clientContactId" v-for="contact in client.contacts">{{ contact.fullName }}</option>
                      <option v-if="showOther" value="-1">Other</option>
                    </select> -->
                    <el-select
                        ref="dropdownEmailSendTo"
                        class="report-to-selecter select-dropdown w-100"
                        :options="listContact"
                        v-model="sendToModel"
                        :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"
                        @change="selectedSendTo"
                        value-key="id"
                        filterable
                        clearable
                        placeholder="Select a Client">
                      <el-option v-for="item in listContact" :key="item.id" :value="item.value" :label="item.name"></el-option>
                    </el-select>
                  </div>
                </div>
                <div v-if="showSendReportToOther" class="box-row" >
                  <div  class="box-col box-col-left left-label">Send report Email</div>
                  <div class="box-col box-col-right">
                    <input :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"  class="textbox" type="text" maxlength="100" :class="hasError && sendReportEmailError ? 'is-invalid' : ''" placeholder="Send report to this email address" v-model="booking.ReportTo"/>
                    <div v-if="hasError && sendReportEmailError" class="text-danger">{{ sendReportEmailError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Payment Details</div>
                  <div class="box-col box-col-right d-flex align-items-center">
                    <img
                      v-if="client.paymentDeferralOption"
                      class="is-icon"
                      src="@/assets/images/payment_deferral_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getFeeDeferralRequiredTitle"
                      :data-original-title="getFeeDeferralRequiredTitle"
                      @click="toggleFeeDeferralRequired()"
                      :class="booking.FeeDeferralRequired ? '' : 'disabled-element'"
                    />
                    <img
                      class="ml-2"
                      src="@/assets/images/prepayment_required_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getPrePaymentRequiredTitle"
                      :data-original-title="getPrePaymentRequiredTitle"
                      @click="togglePrePaymentRequired"
                      :class="booking.PrepaymentRequired ? '' : 'disabled-element'"
                    />
                    <!-- <img class="ml-4" src="@/assets/images/finance_black_icon.svg" @click="togglePaid()" :class="booking.paid == true ? '' : 'disabled-element'" /> -->
                    <img
                      class="ml-4 is-icon"
                      src="@/assets/images/specialist_black_icon.svg"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getSpecialistConfirmedHoursTitle"
                      :data-original-title="getSpecialistConfirmedHoursTitle"
                      @click="toggleSpecialistConfirmedHours()"
                      :class="booking.SpecialistConfirmedHours ? '' : 'disabled-element'"
                    />
                    <img v-if="user.type === 4 || user.type === 6 && !this.hidePurchaseOrderButton" @click="goToPurchaseOrder()" class="right-element is-icon" src="@/assets/images/view_booking.svg"/>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Bill To</div>
                  <div class="box-col box-col-right">
                    <!-- <select class="w-75 px-2" v-model="booking.billTo">
                      <option value="" hidden>Please choose ...</option>
                      <option :value="contact.clientContactId" v-for="contact in client.contacts">{{ contact.fullName }}</option>
                    </select> -->
                    <el-select
                      ref="dropdownEmailBillTo"
                      class="email-to-selecter select-dropdown w-100"
                      v-model="billToModel"
                      :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"
                      @change="selectedBillTo"
                      value-key="id"
                      filterable
                      clearable
                      placeholder="Select a Client">
                      <el-option v-for="item in listContact" :key="item.id" :value="item.value" :label="item.name"></el-option>
                    </el-select>
                  </div>
                </div>
                <div v-if="showBillToEmail" class="box-row">
                  <div class="box-col box-col-left left-label">Bill to Email</div>
                  <div class="box-col box-col-right">
                    <input :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"  class="textbox" type="text" placeholder="Bill to this email address" :class="hasError && billToEmailError ? 'is-invalid' : ''" v-model="booking.BillTo"/>
                    <div v-if="hasError && billToEmailError" class="text-danger">{{ billToEmailError }}</div>
                  </div>
                </div>

                <div v-if="hasError && additionalHoursReasonError" class="box-row">
                  <div class="box-col box-col-left left-label"></div>
                  <div class="box-col box-col-right"><div class="text-danger">{{ additionalHoursReasonError }}</div></div>
                </div>
                <div class="box-row" v-for="(hour, index) in booking.BookingHours" :key="additionalTime + index">
                  <div class="box-col box-col-left left-label">{{ index == 0 ? 'Additional Time' : '' }}</div>
                  <div class="box-col box-col-right d-flex align-items-center ml-2">
                    {{ hour.service }}: {{ hour.numberOfHours + (hour.numberOfHours == 1 ? ' Hour' : ' Hours') }}
                    <div class="right-element">
                      <v-btn  class="add-icon add-black-icon" style="background-color:#C4C4C4;color:#6686B6F" @click="openServiceTimeModal" v-if="index == 0">Add New</v-btn>
                    </div>
                    <el-tooltip :content="hour.reason">
                      <div class="ml-2 mr-2 text-overflow-hide">
                        {{hour.reason}}
                      </div>
                    </el-tooltip>
                    <div style="position: absolute; left: 50%; width: 150px">
                      <select :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"  v-if="hour.bookingHoursStatus != 1" @change="updateStatus($event, index)" v-model="hour.bookingHoursStatus">
                        <option v-for="status in additionalHoursStatus" :value="status.id">{{ status.name }}</option>
                      </select>
                      <span v-else class="pl-2">Approved</span>
                    </div>
                  </div>
                </div>
                <div class="box-row" v-if="booking.BookingHours.length == 0">
                  <div class="box-col box-col-left left-label">Additional Time</div>
                  <div class="box-col box-col-right d-flex align-items-center">
                    <div class="right-element">
                      <v-btn :disabled="booking.Status.StatusID === 6 || booking.Status.StatusID === 7"  class="add-icon add-black-icon" style="background-color:#C4C4C4;color:#6686B6F" @click="openServiceTimeModal">Add New</v-btn>
                    </div>
                  </div>
                </div>
                <AdminAddServiceTimeModal ref="adminAddServiceTimeModal" :bookingProps="booking" :roleProps="roleProps" />

                <div class="box-row">
                  <div class="box-col box-col-left left-label">Total Approved Additional Hours</div>
                  <div class="box-col box-col-right d-flex align-items-center">
                    {{booking.totalApproveHour ? booking.totalApproveHour.toFixed(2) : 0}}
                  </div>
                </div>
                <div class="box-row">
                  <div v-if="user.type >= 3" class="box-col" style="line-height: 1.5; padding: 0.5rem 20px; font-weight: 500">
                    Allocated Admin: {{booking.ZohoAdminOwner}}
<!--                    <el-select :loading="loadingUser" clearable filterable remote :remote-method="remoteUser" placeholder="Allocated Admin" class="w-100" v-model="booking.assignedTo">-->
<!--                      <el-option v-for="item in users" :key="item.id" :value="item.id" :label="item.name">{{ item.name }}</el-option>-->
<!--                    </el-select>-->
                  </div>
                  <div class="box-col d-flex align-items-center justify-content-end w-100 p-2 flex-wrap">
                    <v-btn class="btn-light m-1" v-if="!hideButton && showSupplementaryService" @click="tapSupplementaryService()">Supplementary Service Request</v-btn>
                    <v-btn dark class="m-1" v-if="showRedRescheduleBtn && !booking.RedRescheduled" @click="tapReschedule">Re-Book Appointment</v-btn>
                    <v-btn dark class="m-1" v-if="!hideButton && booking.Status.StatusID < 6" @click="tapCancel">Cancel Booking</v-btn>
                    <v-btn class="btn-light m-1" v-if="!hideButton && booking.Status.StatusID <= 6" @click="requestAction()">Request Action</v-btn>
                    <v-btn class="btn-light m-1" v-if="hideButton" @click="tapDelete()">Delete</v-btn>
                    <v-btn class="btn-light m-1" v-if="isTPD" @click="tapHold()">{{booking.TPDAssistOnHold ? 'Take Off Hold' : 'Place On Hold'}}</v-btn>
                    <v-btn class="m-1" :class="!enableButton || !hasChange ? 'disabled-element' : ''" dark @click="updateBooking()">Update</v-btn>
                  </div>
                </div>
                <RequestActionModal ref="requestActionModal" />
              </div>
            </div>
          </div>
          <div class="col-3 action-log d-inline-block m-0 p-0" style="vertical-align:top; height: 1000px;">
            <div style="display: flex;flex-direction: row;">
              <span style="line-height: 3; padding-left: 20%">Booking Log</span>
              <select @change="updateBookingLog($event)" class="ml-3 small-selector">
                <option value="0">Recent</option>
                <option value="1">View All</option>
              </select>
            </div>
            <Timeline :timeline="timelineData" />
          </div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger general-alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>
        <div class="alert alert-danger alert-warning-no-confirm hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>
        <div class="alert alert-danger alert-warning-confirm  hidden-element">
          <div class="icon-group center-element">
            <v-btn class="alert-button" @click="tapCancelConfirmation(true)">Ok</v-btn>
          </div>
          <b>Error:</b> {{errorMessage}}
        </div>

        <div class="box remove-min-height">
<!--          <div class="box-heading d-flex align-items-center">-->
<!--            Tests Ordered-->
<!--            <div class="right-element">-->
<!--              <v-btn class="add-icon" :disabled="booking.Status.StatusID === 6" dark @click="openTestsModal">Add New</v-btn>-->
<!--              <AddSpecialistBookingTestModal ref="addSpecialistBookingTestModal" :bookingProps="booking" :testsProps="test" />-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <div class="box">

          <div class="box-heading tab">
            <div class="tab-heading tab-selected px-5" id="heading-notes" @click="openTab(0)">Notes</div>
            <div class="tab-heading px-5" id="heading-files" @click="openTab(1)">Files</div>
            <div class="tab-heading px-5" id="heading-billing" @click="openTab(2)">Billing Notes</div>
            <div class="tab-heading px-5" id="heading-logs" @click="openTab(3)">Comms Log</div>
            <el-badge :hidden="getCount() === 0" :value="getCount()" class="item">
            <div class="tab-heading px-5" id="heading-specialist" @click="openTab(4)">Specialist Communication</div>
            </el-badge>
            <div class="right-element">
              <v-btn v-if="curTab === 1 && booking.bookingFiles.filter(item => item.checked).length > 0" class="download-icon mr-2" dark @click="downloadFiles">Download</v-btn>
              <v-btn v-if="curTab !== 3" class="add-icon" dark @click="openAddNew">Add New</v-btn>
              <AddNoteModal ref="addNoteModal" :isBilling="isBilling" :bookingProps="booking" fromProps="admin" />
            </div>
            <div v-if="hasError && notesAndBillingFormatError" class="text-danger w-100 pl-3">{{ notesAndBillingFormatError }}</div>
          </div>
          <div class="box-body tab-content tab-content-boxes hidden-element">
            <div class="box-row" v-for="(item, index) in bookingNoteAndActions" :key="index">
              <div class="box-col box-col-left" style="width: 12%">{{decodeURIComponent(item.userName)}}</div>
              <div class="box-col box-col-left" style="width: 13%">
                <!-- {{item.noteDateTime}} -->
                <p v-if="item.deleted">
                  <del>{{ formatDate(item.dateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }} </del>
                </p>
                <p v-else>{{ formatDate(item.dateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }}</p>
              </div>
              <div v-if="item.type === 'note'" @click="editNote(index)" style="width: width: 75%" class="box-col box-col-right box-col-long col-center-content">
                <p v-if="item.deleted" style="line-height: 1.5;word-break: break-word">
                  <del>{{ decodeURIComponent(item.note) }}</del>
                </p>
                <p v-else style="line-height: 1.5;word-break: break-word">{{ decodeURIComponent(item.note) }}</p>
              </div>
              <div v-else class="box-col box-col-right box-col-long col-center-content" style="width: 75%">
                <strong>Requested Action: </strong>{{ decodeURIComponent(item.note) }}
              </div>
              <div class="pr-8 center-title">
                <img v-if="item.internalOnly === 1" src="@/assets/images/eye-private.svg" />
              </div>
              <div v-if="item.type === 'note' && !item.deleted"  class="is-icon center-title" @click="deleteNote(item, index)">
                <img :class="(item.userId !== user.id) ? 'disabled-element' : ''" src="@/assets/images/delete_icon.svg" />
              </div>
            </div>
          </div>

          <div class="box-body tab-content tab-content-boxes hidden-element">
            <div>
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width:4%">
                        <el-checkbox @change="handleAllSelect"></el-checkbox>
                      </th>
                      <th style="width:14%" class="long-text">
                        File Type
                        <img v-if="listParam.SortFlag === 1" class="sort-icon" :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(2)" />
                        <img v-else-if="listParam.SortFlag === 2" class="sort-icon" :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)" />
                        <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')" @click="sortParam(1)"   />
                      </th>
                      <th style="width:22%" class="long-text">
                        File Name
                        <img v-if="listParam.SortFlag === 3" class="sort-icon" :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(4)" />
                        <img v-else-if="listParam.SortFlag === 4" class="sort-icon" :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)" />
                        <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')" @click="sortParam(3)"   />
                      </th>
                      <th style="width:15%" class="long-text">
                        Uploaded By
                        <img v-if="listParam.SortFlag === 5" class="sort-icon" :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(6)" />
                        <img v-else-if="listParam.SortFlag === 6" class="sort-icon" :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)" />
                        <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')" @click="sortParam(5)"   />
                      </th>
                      <th style="width:15%" class="long-text">
                        Date Uploaded
                        <img v-if="listParam.SortFlag === 7" class="sort-icon" :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(8)" />
                        <img v-else-if="listParam.SortFlag === 8" class="sort-icon" :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)" />
                        <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')" @click="sortParam(7)"   />
                      </th>
                      <th style="width:10%" class="icon-col">
                        Status
                        <img v-if="listParam.SortFlag === 9" class="sort-icon" :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(10)" />
                        <img v-else-if="listParam.SortFlag === 10" class="sort-icon" :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)" />
                        <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')" @click="sortParam(9)"   />
                      </th>
                      <th style="width:10%" class="icon-col">Version Count</th>
                      <th style="width:10%" class="icon-col"><div class="icon-group">&nbsp;</div></th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="content-scroll-y" style="height:auto;max-height:460px;">
                <table class="table remove-min-height">
                  <tbody :key="fileKey">
                    <tr v-for="(file, index) in booking.bookingFiles" :key="index" class="py-0" :class="file.IsDeleted ? 'deleted-file' : ''">
                      <th style="width:4%" class="long-text">
                        <el-checkbox size="large" v-model="file.checked" @change="onChangeSelectFile($event, file)"></el-checkbox>
                      </th>
                      <th style="width:14%" class="long-text">
                        <select v-model="file.FileTypeID" :disabled="user.type === 4" @change="updateFileType(file.BookingFileID, index)">
                          <option value="" hidden>Select File Type</option>
                          <option v-for="fileType in fileTypes" :key="fileType.FileTypeID" :value="fileType.FileTypeID">{{ fileType.FileTypeName }}</option>
                        </select>
                        <!-- <span v-else style="padding-left: 10px;">{{ file.fileTypeName }}</span> -->
                      </th>
                      <th style="width:22%" class="long-text">
                        <el-tooltip v-if="!file.editing" effect="dark" :content="decodeURIComponent(file.FileName)">
                          <span style="cursor: pointer" @click="getFileUrl(file)" >{{ decodeURIComponent(file.FileName) }}</span>
                        </el-tooltip>
                        <el-input style="width: 60%" v-else v-model="newFileName" />
<!--                        <div class="ml-3 d-inline">-->
<!--                          <i @click="onChangeEditing(file)" v-if="!file.editing" class="el-icon-edit cursor-pointer"></i>-->
<!--                          <div class="d-inline" v-else>-->
<!--                            <i @click="onSaveEditing(file, index)"  class="el-icon-check cursor-pointer mr-2"></i>-->
<!--                            <i @click="onCancelEditing(file)"  class="el-icon-close cursor-pointer"></i>-->
<!--                          </div>-->
<!--                        </div>-->
                      </th>
                      <th style="width:15%" class="long-text">
                        {{ decodeURIComponent(file.UploadedUser.UserName)}}
                      </th>
                      <th style="width:15%" class="long-text">
                        {{ formatDate(file.DateUploaded, 'DD/MM/YYYY HH:mm',  "YYYY-MM-DD HH:mm:ss.ssssss")}}
                      </th>
                      <th style="width:10%" class="long-text">
                        <el-select v-model="file.FileStatus" @change="finalizeFile(file.BookingFileID, index)">
                          <el-option v-for="status in fileStatus" :value="status.id" :key="status.id" :label="status.name">{{ status.name }}</el-option>
                          <el-option v-if="file.FileTypeID === 3" value="2" label="Complete">Complete</el-option>
                          <el-option v-if="file.FileTypeID === 3" value="3" label="For Review">For Review</el-option>
                        </el-select>
                        <!-- <span v-else>Final</span> -->
                      </th>
                      <th style="width:10%" class="long-text">
                        {{ file.VersionCount}}
                      </th>
                      <th style="width:10%; vertical-align:middle" class="icon-col">
                        <div v-if="file.VersionCount === 1" class="icon-group d-flex justify-content-center">
                          <img src="@/assets/images/download_icon.svg" @click="getFileUrl(file)" />
                          <img style="margin-left: 20px" src="@/assets/images/delete_icon.svg" @click="deleteFile(file.BookingFileID, file.FileName, booking.BookingID)" />
                        </div>
                        <div v-else class="icon-group d-flex justify-content-center">
                          <img src="@/assets/images/eye-icon.svg" @click="showVersionModal(file)" />
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="box-col">
              <div class="file-upload-area border-gray-300 mt-5 mb-5" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                <input
                  type="file"
                  multiple
                  name="fields[assetsFieldHandle][]"
                  id="assetsFieldHandle"
                  class="w-px h-px opacity-0 overflow-hidden absolute"
                  @change="onChange"
                  ref="file"
                  accept="" />
                <label for="assetsFieldHandle" class="block cursor-pointer d-flex flex-column justify-content-center align-items-center">
                  <div>Drop files in this area or <span style="text-decoration:underline" class="is-icon">click here</span> to upload files.</div>
                  <div>Files over 200MB in file size may cause errors. If you need to upload files of this size, please contact us on 1300 100 733</div>
                </label>
                <FileTypeModal ref="fileTypeModal" />
              </div>
            </div>
          </div>
          <div v-show="isBilling" class="box-body tab-content tab-content-boxes">
            <div class="box-row" v-for="(item, index) in billingNoteAndActions" :key="index">
              <div class="box-col box-col-left" style="width: 12%">{{decodeURIComponent(item.userName)}}</div>
              <div class="box-col box-col-left" style="width: 13%">
                <!-- {{item.noteDateTime}} -->
                <p v-if="item.deleted">
                  <del>{{ formatDate(item.dateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }} </del>
                </p>
                <p v-else>{{ formatDate(item.dateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }}</p>
              </div>
              <div v-if="item.type === 'note'" @click="editNote(index)" style="width: width: 75%" class="box-col box-col-right box-col-long col-center-content">
                <p v-if="item.deleted" style="line-height: 1.5; word-break: break-word">
                  <del>{{ decodeURIComponent(item.note) }}</del>
                </p>
                <p v-else style="line-height: 1.5;word-break: break-word">{{ decodeURIComponent(item.note) }}</p>
              </div>
              <div v-else class="box-col box-col-right box-col-long col-center-content" style="width: 75%">
                <strong>Requested Action: </strong>{{ decodeURIComponent(item.note) }}
              </div>
              <div class="pr-8 center-title">
                <img v-if="item.internalOnly == 1" src="@/assets/images/eye-private.svg" />
              </div>
              <div v-if="item.type == 'note' && !item.deleted"  class="is-icon center-title" @click="deleteNote(item, index)">
                <img :class="(item.userId != user.id) ? 'disabled-element' : ''" src="@/assets/images/delete_icon.svg" />
              </div>
            </div>
          </div>
          <div class="box-body tab-content tab-content-boxes hidden-element logs">
            <table class="table">
              <thead>
              <tr>
                <th style="width:15%" class="long-text">User</th>
                <th style="width:35%" class="long-text">Recipient</th>
                <th style="width:23%" class="long-text">Subject</th>
                <th style="width:18%" class="long-text">Date/Time sent</th>
                <th style="width:10%" class="long-text">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in commonLogs" :key="index" class="py-0">
                <td style="width: 15%" >{{decodeURIComponent(item.Username)}}</td>
                <td style="width: 35%; text-overflow: ellipsis;white-space: nowrap; overflow: hidden;" :title="decodeURIComponent(item.Recipient)" >{{decodeURIComponent(item.Recipient)}}</td>
                <td style="width: 23%; text-overflow: ellipsis;white-space: nowrap; overflow: hidden;" :title="item.CommuType === 1 ? item.Subject : ''" >{{item.CommuType === 1 ? item.Subject : ''}}</td>
                <td style="width: 18%" >{{getDate(item.LogDate)}}</td>
                <td @click="showEmailBody(item)" class="cursor-pointer" style="color: #3FA2F7" >
                  View
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="box-body tab-content tab-content-boxes hidden-element">
            <div class="box-row d-flex flex-column pt-2 pb-2" v-for="(note, index) in notesList" :key="index" :style="{'text-decoration': note.Deleted ? 'line-through' : 'none'}">
              <div class="d-flex align-content-center w-100">
                <div class="box-col box-col-left is-icon" >
                  {{ decodeURIComponent(note.UsernameLog) }}
                </div>
                <div class="box-col box-col-left">{{ formatDate(note.NoteDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssssss") }}</div>
                <div style="max-width: 60%; line-height: 1.5" class="box-col box-col-right" data-toggle="tooltip" data-placement="right" :title="note.Note">
                  {{ note.Note }}
                </div>
              </div>
              <div class="d-flex align-center w-100" v-for="item in note.children" :key="item.SpecialistRequestNoteID">
                <div class="box-col box-col-left is-icon" >
                  {{ decodeURIComponent(item.UsernameLog) }}
                </div>
                <div class="box-col box-col-left">{{ formatDate(item.NoteDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssssss") }}</div>
                <div style="max-width: 60%; line-height: 1.5" class="box-col box-col-right" data-toggle="tooltip" data-placement="right" :title="item.Note">
                  {{ item.Note }}
                </div>
              </div>
            </div>
          </div>
          <div class="alert alert-warning confirmation hidden-element">
            <a class="close" title="close" @click="tapButtonConfirmation(false)">×</a>
            <b>Warning:</b> Are you sure? Your changes will take effect immediately.
            <div class="icon-group">
              <v-btn class="alert-button" @click="tapButtonConfirmation(true)">Yes</v-btn>
              <v-btn class="alert-button" @click="tapButtonConfirmation(false)">No</v-btn>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <el-dialog
        class="no-padding-dialog"
        :title="currentReply ? 'Reply Note' : 'New Note'"
        :visible.sync="noteDialogVisible"
        @close="closeModal"
        width="50%">
      <div>
        <textarea rows="4" type="text" @keydown.enter.prevent="submitForm" v-model="requestNotes" class="textbox" maxlength="1000" placeholder="Enter a note" />
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn class="white-button me-2" dark @click="closeModal">Cancel</v-btn>
    <v-btn dark @click="submitForm">Save</v-btn>
  </span>
    </el-dialog>
    <el-dialog
        class="edit-zoho-dialog"
        title="Version List"
        :visible.sync="versionVisible"
        width="50%">
      <div>
        <el-table :data="versionList">
          <el-table-column
              show-overflow-tooltip
              prop="FileTypeName"
              label="File Type"
          >
            <div slot-scope="item">
              {{ item.row.FileType.FileTypeName}}
            </div>
          </el-table-column>
          <el-table-column
              show-overflow-tooltip
              prop="FileSize"
              label="Size"
          >
            <div slot-scope="item">
              {{ (item.row.FileSize / 1024).toFixed(2)}}KB
            </div>
          </el-table-column>
          <el-table-column
              show-overflow-tooltip
              prop="FileSize"
              label="Upload Time"
          >
            <div slot-scope="item">
              {{formatDate(item.row.LastModified, 'MM/DD/YYYY HH:mm', "YYYY-MM-DD HH:mm:ss.ssss")}}
            </div>
          </el-table-column>
          <el-table-column
              show-overflow-tooltip
              prop="UploadedUser"
              label="Upload By"
          >
            <div slot-scope="item">
              {{decodeURIComponent(item.row.UploadedUser.UserName)}}
            </div>
          </el-table-column>
          <el-table-column
              show-overflow-tooltip
              prop="FileSize"
              label="Action"
          >
            <div slot-scope="file">
              <img style="cursor: pointer" src="@/assets/images/download_icon.svg" @click="getFileUrl(file.row)" />
              <img style="margin-left: 20px; cursor: pointer" src="@/assets/images/delete_icon.svg" @click="deleteVersionFile(file.row, file)" />
            </div>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <v-btn dark @click="deleteFile(currentFile.BookingFileID, currentFile.FileName, booking.BookingID)">Remove All</v-btn>
      </span>
    </el-dialog>
    <InterpreterDetailDialog ref="interpreterModal" :user="user"  @clickSave="handleSaveInterpreterDetail"/>
    <SurrogateDetailDialog ref="SurrogateModal"  @clickSave="handleSaveInterpreterDetail"/>
    <CancelBookingModal v-if="booking.BookingID" ref="cancelBookingModal"/>
    <AdminManageContactDetailsModal v-if="booking.BookingID" ref="adminManageContactModal" />
    <AdminSendEmailModal v-if="booking.BookingID" @sendSuccess="sendSuccess" :client="client" :specialist="booking.Specialist" :clientContact="clientContacts" :bookingProps="booking" :locationName="booking.Location ? getLocationName(booking.Location.LocationID || ''): ''" :sendToProps="sendToProps" :bookingFiles="booking.bookingFiles" :emailProps="emails" :nameProps="names" :phoneProps="phones" :emailSmsProps="emailOrSms" ref="adminSendEmailModal" />
    <el-dialog  title="Select TimeZone" :visible.sync="showTimeZone">
      <div>
        <el-select filterable v-model="timeZoneValue">
          <el-option v-for="item in timeZones" :key="item" :value="item" :label="item"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn dark class="white-button" @click="cleanData">Cancel</v-btn>
    <el-button type="primary" @click="showTimeZone = false;">OK</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import InterpreterDetailDialog from "@/components/dialog/InterpreterDetailDialog.vue";
  import SurrogateDetailDialog from "@/components/dialog/SurrogateDetailDialog.vue";
  import AdminBookingsMenu from '@/components/AdminBookingsMenu'
  import Header from '@/components/Header'
  import AddNoteModal from '@/components/AddNoteModal'
  import Timeline from '@/components/Timeline'
  import CancelBookingModal from '@/components/CancelBookingModal'
  import AdminManageContactDetailsModal from '@/components/AdminManageContactDetailsModal'
  import AdminSendEmailModal from '@/components/AdminSendEmailModal'
  import AdminAddServiceTimeModal from '@/components/AdminAddServiceTimeModal'
  import RequestActionModal from '@/components/RequestActionModal'
  import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'
  import FileTypeModal from '@/components/FileTypeModal'
  import JSZip from "jszip";
  import FileSaver from "file-saver";
  import business from 'moment-business-days';

  export default {
    name: 'AdminManageBooking',
    components: {
      AdminNavigation,
      AdminBookingsMenu,
      Header,
      AdminManageContactDetailsModal,
      AddNoteModal,
      Timeline,
      AdminSendEmailModal,
      AdminAddServiceTimeModal,
      RequestActionModal,
      AddBodyDiagramModal,
      FileTypeModal,
      CancelBookingModal,
      InterpreterDetailDialog,
      SurrogateDetailDialog
    },
    data() {
      return {
        reugularContacts: [],
        contacts: [],
        ShowVideoLinkUrl: false,
        bookingWithNoAvailability: false,
        timeZones: [],
        timeZoneValue: null,
        showTimeZone: false,
        listParam: {
          SortFlag: 0,
        },
        showSHORT: false,
        showMAS: false,
        showPIC: false,
        showRedRescheduleBtn: false,
        requestBookingHour: null,
        requestNotes: '',
        noteDialogVisible: false,
        curTab: 0,
        newFileName: '',
        notesList: [],
        currentNotes: null,
        loadingUser:false,
        userParam: {
          pageSize: 20,
          pageNum: 1,
          orderBy: 'UserStatus',
          ascOrDesc: 'DESC',
          UserName: null,
          UserRoleID: '3,6',
        },
        statesNew: utilities.getStates(),
        commonParam: {
          PageSize: 10,
          PageNum: 1,
          BookingID: this.$route.query.id
        },
        commonsCount: 0,
        currentFile: null,
        versionVisible: false,
        showLinkLocation: true,
        curSpecialty: '',
        billToModel: null,
        sendToModel: null,
        isBilling: false,
        dialogVisible: false,
        bodyAreasTag: '',
        conditionTag: '',
        originalStatus: '',
        hasError: false,
        loaded: false,
        focused: '',
        focusDropdown: false,
        specialistFocus: false,
        bookingFocus: false,
        locationFocus: false,
        bookingTypeFocus: false,
        attendanceStatusFocus: false,
        paperworkStatusFocus: false,
        sendReportToFocus: false,
        onBehalfOfFocus: false,
        billToFocus: false,
        preApprovedHoursFocus: false,
        hoursForFocus: false,
        interpreterRequired: false,
        surrogateRequired: false,
        showSurrogate: true,
        showError: false,
        showOther: false,
        showContent: true,
        isTimeChanged: false,
        showTime: true,
        enableButton: true,
        isBookingDateChanged: false,
        isValidPaperworkDue: true,
        hideButton: false,
        isValidAccidentDate: true,
        showSupplementaryService: false,
        commonLogs: [],

        showBillToEmail: false,
        showSendReportToOther: false,
        listContact: [],
        originalClientContacts: [],
        togglePeriodOfTime: false,

        overTime: false,
        bodyAreaTag: "",
        otherBodyAreaTag: "",
        personConditionTag: "",
        bodyAreas: [],
        bodyAreaTags: [],
        otherBodyAreaTags: [],
        originalOtherBodyAreaTags: [],
        deletedBodyTags: [],
        personConditions: [],
        personConditionTags: [],
        originalPersonConditionTags: [],
        deletedConditionTags: [],
        addedBodyArea: [],
        addedConditions: [],
        isLolChanged: false,
        isBrirgChanged: false,
        isAdditionalChanged: false,
        isPaperworkChanged: false,
        isChangedAttendance: false,
        isChangedConsent: false,
        isShowForBooking: true,
        isShowBookingTime: false,
        hidePurchaseOrderButton: false,
        clients: [],
        test: -1,

        requestedExtraHours: [
          {
            hours: 1,
            hoursFor: 1,
          },
        ],

        specialists: [],
        specialist: [],
        bodyAreasTags: [],
        conditionTags: [],
        filelist: [],
        locations: [],
        bodyAreasAutocomplete: [],
        conditionsAutocomplete: [],
        clientContacts: [],
        paperworkStatuses: [],
        bookingNoteAndActions: [],
        billingNoteAndActions: [],
        standardFiles: [],
        availableTimes: [],
        states: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          },
        },
        bookingStatuses: utilities.getBookingStatuses().filter(item => item.id !== 6), // booking status without cancel
        bookingTypes: [],
        claimTypes: [],
        booking: utilities.initBooking(),
        originalBooking: utilities.initBooking(), // original booking
        fileStatus: utilities.getFileStatus(),
        statusList: utilities.getStatus(),
        bookingLogs: [],
        timelineData: [],
        minimumAppointment: [],
        isUpdated: false,
        isDisabled: false,
        disableBookingType: true,
        currentReply: {},
        bookingExamineeStatus: [],
        oldExamineeStatus: [],
        reports: [
          {
            id: 1,
            name: 'John',
          },
          {
            id: 2,
            name: 'Kate',
          },
        ],
        deleteId: '',
        deleteIndex: '',
        roleProps: 'admin',

        sendToProps: '',

        successMessage: '',
        errorMessage: '',
        emails: {},
        bookingAction: [],
        fileTypeId: 0,
        fileTypes: [],
        fileKey: 1,
        users: [],
        bookingDate: null,
        bookingTime: moment().format('hh:mm A'),
        originalBookingDate: '',
        originalBookingTime: '',
        bookingOldDateTime: '',
        statusKey: 0,
        singleCase: {},
        client: {},
        names: [],
        additionalHoursStatus: utilities.getAdditionalHoursStatuses(),
        versionList: [],
        phones: {},
        emailOrSms: 0,
        noteKey: 0,
        timeKey: 0,
        additionalTime: 0,
        minLength: 60,
        availabilityEndTime: '',
        newSlot: [],
        specialistTimes: [],
        showDelivery: false
      }
    },
    watch: {
      booking: {
        handler(value) {
          if (this.loaded) {
            this.$store.dispatch("setNewObject", value)
            let originalObject = this.$store.getters["getOriginalObject"]
            originalObject.billingNotes = value.billingNotes
            originalObject.bookingNotes = value.bookingNotes
            originalObject.bookingFiles = value.bookingFiles
            this.$store.dispatch("setOriginalObject", originalObject)
          }
        },
        deep: true,
      },
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      showOriginalClientContact() {
        return !!(this.booking.OriginalClientContactID && this.booking.ClientContactID != this.booking.OriginalClientContactID)
      },
      originalClientContactDisplay() {
        const contact = this.booking.OriginalClientContact
        if (!contact) return ''
        if (typeof contact === 'string') return contact
        return contact.ClientContactFullName + '-' + contact.EmailAddress
      },
      isTPD() {
        return this.booking.BookingTypeID === 19
      },
      deliveryMethodError() {
        if (!utilities.bookingTypeWithDeliveryMethods(this.booking.BookingTypeID)) {
          return ''
        }
        if (!this.booking.DeliveryMethodID) {
          return 'Please select a delivery method.'
        }
        return ''
      },
      incidentStateError() {
        if (!this.booking.IncidentState || String(this.booking.IncidentState).trim() === '') {
          return 'State where the incident occurred is required.'
        }
        return ''
      },
      numOfServicesError() {
        if (this.booking.BookingTypeID !== 19) {
          return ''
        }
        if (!this.showSHORT && !this.showMAS && !this.showPIC) {
          return 'Please select at least one service type (MAS, PIC, or Short Report) and enter a number.'
        }
        if ((this.showSHORT && !this.booking.ShortReport) || (this.showMAS && !this.booking.MAS) || (this.showPIC && !this.booking.PIC)) {
          return 'Please enter a number (1–10) for each selected service type.'
        }
        return ''
      },
      clientReferenceError() {
        return utilities.getAdminBookingClientReferenceError(this.booking.ClientReference)
      },
      referralTypeError() {
        if (!this.booking.ClaimTypeID) {
          return 'Referral type is required.'
        }
        return ''
      },
      billToEmailError() {
        if (!this.showBillToEmail) {
          return ''
        }
        const s = String(this.booking.BillTo || '').trim()
        if (!s) {
          return 'Bill to email is required.'
        }
        return utilities.getClientContactEmailError(this.booking.BillTo, 'Bill to email', false)
      },
      sendReportEmailError() {
        if (!this.showSendReportToOther) {
          return ''
        }
        const s = String(this.booking.ReportTo || '').trim()
        if (!s) {
          return 'Send report email is required.'
        }
        return utilities.getClientContactEmailError(this.booking.ReportTo, 'Send report email', false)
      },
      examineeStateError() {
        if (this.booking.DeliveryMethodID !== 2 || this.isTPD) {
          return ''
        }
        if (!this.bookingExamineeStatus || this.bookingExamineeStatus.length === 0 || !this.bookingExamineeStatus[0]) {
          return 'Examinee state is required.'
        }
        return ''
      },
      examineeLocationError() {
        if (this.booking.DeliveryMethodID !== 2) {
          return ''
        }
        return utilities.getExamineeLocationForVideoLinkError(this.booking.ClaimantLocation)
      },
      bookingTimeError() {
        if (!utilities.bookingTypeWithAvailability(this.booking.BookingTypeID)) {
          return ''
        }
        if (!this.bookingTime || this.bookingTime === '') {
          return 'Booking time is required.'
        }
        return ''
      },
      clientContactError() {
        if (!this.booking.ClientContactID) {
          return 'Client contact is required.'
        }
        return ''
      },
      otherBodyAreasError() {
        return utilities.getAdminBookingOtherBodyAreasError(this.otherBodyAreaTags)
      },
      additionalHoursReasonError() {
        const hours = this.booking.BookingHours || []
        for (let i = 0; i < hours.length; i++) {
          const err = utilities.getAdminBookingAdditionalTimeReasonError(hours[i].reason)
          if (err) {
            return err
          }
        }
        return ''
      },
      bookingNotesContentError() {
        const list = this.booking.bookingNotes || []
        for (let i = 0; i < list.length; i++) {
          const row = list[i]
          if (row.Deleted || row.deleted) {
            continue
          }
          let text = row.Note || row.note || ''
          try {
            text = decodeURIComponent(text)
          } catch (e) {
            /* keep raw */
          }
          const err = utilities.getBookingRequestNoteError(text)
          if (err) {
            return err
          }
        }
        return ''
      },
      billingNotesContentError() {
        const list = this.booking.billingNotes || []
        for (let i = 0; i < list.length; i++) {
          const row = list[i]
          if (row.Deleted || row.deleted) {
            continue
          }
          let text = row.Note || row.note || ''
          try {
            text = decodeURIComponent(text)
          } catch (e) {
            /* keep raw */
          }
          const err = utilities.getBookingRequestNoteError(text)
          if (err) {
            return err
          }
        }
        return ''
      },
      notesAndBillingFormatError() {
        return [this.bookingNotesContentError, this.billingNotesContentError].filter(Boolean).join(' ')
      },
      paperworkDueError() {
        if (this.booking.OverPeriodofTime) {
          return ''
        }
        const pd = this.booking.PaperworkDue

        if (!pd || pd === '') {
          return ''
        }
        if (moment(pd, 'YYYY-MM-DD', true).isValid() || pd === '0000-00-00') {
          return ''
        }
        if (moment(pd).isValid()) {
          return ''
        }
        return 'Paperwork due is not a valid date.'
      },

      getCaseOwnerName() {
        if (this.booking == undefined || this.booking.BookingID == '') {
          return
        }
        if (this.booking.ClientContact) {
          return this.booking.clientContacts[0].clientContactFullName
        } else {
          if (this.client.contacts == undefined || this.client.contacts.length == 0) return ''
          let caseOwner;
          caseOwner = this.client.contacts[0]
          if (caseOwner != undefined) {
            return caseOwner.fullName
          } else {
            return ' '
          }
        }
      },

      getCaseOwnerPhone1() {
        if (this.booking.clientContacts.length > 0) {
          return this.booking.clientContacts[0].phone
        } else {
          if (this.client.contacts == undefined || this.client.contacts.length == 0) return ''
          let caseOwner;
          caseOwner = this.client.contacts[0]
          if (caseOwner != undefined) {
           return caseOwner.phoneNumber1
          } else {
            return ' '
          }
        }
      },
      getCaseOwnerMobile() {
        if (this.booking.clientContacts.length > 0) {
          return this.booking.clientContacts[0].mobile
        } else {
          if (this.client.contacts == undefined || this.client.contacts.length == 0) return ''
          const caseOwner = this.client.contacts[0]
          if (caseOwner != undefined) {
           return caseOwner.mobile
          } else {
            return ' '
          }
        }
      },
      getCaseOwnerPhone2() {
        if (this.booking.clientContacts.length > 0) {
          return this.booking.clientContacts[0].phone2
        } else {
          if (this.client.contacts == undefined || this.client.contacts.length == 0) return ''
          caseOwner = this.client.contacts[0]
          if (caseOwner != undefined) {
           return caseOwner.phoneNumber2
          } else {
            return ' '
          }
        }
      },
      getCaseOwnerEmail() {
        if (this.booking.ClientContact) {
          return this.booking.ClientContact.NotificationEmailAddress || this.booking.ClientContact.Email
        } else {
          return ''
        }
      },

      getAttendanceTitle() {
        var title = "Examinee attendance " + (this.isDate(this.booking.ClaimantConfirmed) || this.booking.ClaimantConfirmed ? "" : "not ") + "confirmed"
        return title
      },

      getCanRingClaimantTitle() {
        var title = this.booking.RedHealthMayContactClaimant ? "Can ring claimant" : "Can not ring claimant"
        return title
      },

      getConsentReceivedTitle() {
        var title = "Examinee consent " + (this.isDate(this.booking.ClaimantConsentReceived) || this.booking.ClaimantConsentReceived ? "" : "not ") + "received"
        return title
      },

      getCallAfterAppointmentTitle() {
        var title = (this.booking.CallClientAfterAppointment ? "Phone " : "No ") + "call required"
        return title
      },

      getVideoLinkTestArrangedTitle() {
        var title = "Video link test " + (this.booking.VideoLinkTestStatus == 1 || this.booking.VideoLinkTestStatus == 2  ? "" : "not ") + "arranged"
        return title
      },

      getHasVideoTitle() {
        var title = "Video link test " + (this.booking.VideoLinkTestStatus == 2 ? "" : "not ") + "completed"
        return title
      },

      getFeeDeferralRequiredTitle() {
        var title = this.booking.FeeDeferralRequired ? "Payment deferral required" : "No payment deferral"
        return title
      },

      getPrePaymentRequiredTitle() {
        var title = "Prepayment " + (this.booking.PrepaymentRequired ? "" : "not ") + "required"
        return title
      },

      getSpecialistConfirmedHoursTitle() {
        var title = "Specialist " + (this.booking.SpecialistConfirmedHours ? "confirmed hours" : "hours not confirmed")
        return title
      },

      hasChange() {
        var result = false
        // Format Accident Date after selected from the calendar
        if(typeof this.booking.accidentDate != 'string' && moment(this.booking.accidentDate, "YYYY-MM-DD").isValid()) {
          this.booking.accidentDate = moment(this.booking.accidentDate, "YYYY-MM-DD").format("YYYY-MM-DD")
        }
        if(this.bookingExamineeStatus.join(',') !== this.oldExamineeStatus.join(',')) {
          result = true
          return result
        }
        if(this.ShowVideoLinkUrl !== !!this.booking.ShowVideoLinkUrl) {
          return true
        }
        // Format Paperwork Due after selected from the calendar
        if(typeof this.booking.PaperworkDue != 'string' && moment(this.booking.PaperworkDue, "YYYY-MM-DD").isValid()) {
          this.booking.PaperworkDue = moment(this.booking.PaperworkDue, "YYYY-MM-DD").format("YYYY-MM-DD")
        }
        this.originalBooking.bookingNotes = _.cloneDeep(this.booking.bookingNotes)
        this.originalBooking.billingNotes = _.cloneDeep(this.booking.billingNotes)
        if(_.isEqual(this.originalBooking, this.booking)
          && _.isEqual(this.originalOtherBodyAreaTags, this.otherBodyAreaTags)
          && _.isEqual(this.originalPersonConditionTags, this.personConditionTags)
          && moment(this.originalBookingDate, "YYYY-MM-DD").isSame(moment(this.bookingDate, "YYYY-MM-DD"))
          && moment(this.originalBookingDate + " " + this.originalBookingTime, "YYYY-MM-DD HH:mm:ss.ssssss").isSame(moment(this.bookingDate + " " + this.bookingTime, "YYYY-MM-DD HH:mm:ss.ssssss"))) {
          result = false
        }
        else {
          result = true
        }
        return result
      },

      formattedAddress() {
        let address = ''
        if (this.singleCase.ClaimantAddressLine1) address += this.singleCase.ClaimantAddressLine1 + ', '
        if (this.singleCase.ClaimantAddressLine2) address += this.singleCase.ClaimantAddressLine2 + ', '
        if (this.singleCase.ClaimantCity) address += this.singleCase.ClaimantCity + ', '
        if (this.singleCase.ClaimantState) address += this.singleCase.ClaimantState + ' '
        if (this.singleCase.ClaimantPostcode) address += this.singleCase.ClaimantPostcode
        return address
      },
      bookingDateTimeComputed: {
        get: function() {
          return moment(this.booking.bookingDateTime, 'YYYY-MM-DD HH:mm:ss.SSSSSS').format('DD/MM/YYYY hh:mm A')
        },
        set: function(newValue) {
          this.booking.bookingDateTime = moment(newValue, 'DD/MM/YYYY hh:mm A').format('YYYY-MM-DD HH:mm:ss')
        },
      },
      isCancelled() {
        return this.$route.query.cancelled != undefined && this.$route.query.cancelled
      },
    },
    methods: {
      getContactInfo() {
        const contact = this.reugularContacts.find(item => item.ClientContactID === this.booking.ClientContactID)
        if(contact) {
          let str = ''
          if(contact.PhoneNumber1 && contact.PhoneNumber1 !== utilities.DEFAULT_MOBILE) {
            str += `<b>L:</b> ${contact.PhoneNumber1}`
          }
          if(contact.PhoneNumber2 && contact.PhoneNumber2 !== utilities.DEFAULT_MOBILE) {
            str += `<b style="margin-left: 5px">P:</b> ${contact.PhoneNumber2}`
          }
          return str
        }
        return ''
      },
      switchShowLink() {
        this.ShowVideoLinkUrl = !this.ShowVideoLinkUrl
      },
      cleanData() {
        this.showTimeZone = false;
        this.timeZoneValue = null;
        this.booking.ClaimantCountryDuringBooking = null
        this.booking.ClaimantStateDuringBooking = null
        this.bookingExamineeStatus = []
      },
      async changeState(e) {
        if(e && e.length > 0) {
          this.booking.ClaimantCountryDuringBooking = e[0]
          this.booking.ClaimantStateDuringBooking = e[1]
          if (e[0] === e[1] && e[1] === "International") {
            await this.$store.dispatch("loading/setLoadComponent", true);
            this.timeZones = await utilities.getTimeZone()
            this.showTimeZone = true
            await this.$store.dispatch("loading/setLoadComponent", false);
          } else {
            this.timeZoneValue = null
          }
          this.$forceUpdate()
        } else {
          this.booking.ClaimantCountryDuringBooking = null
          this.booking.ClaimantStateDuringBooking = null
        }
      },
      onChangeNum(name, value) {
        console.log(name)
        if (value) {
          this.$set(this.booking, name, 1)
        } else {
          this.$set(this.booking, name, 0)
        }

      },
      tapReschedule() {
        this.$router.replace('admin-search-specialist?rescheduleId=' + this.booking.BookingID)
      },
      handleSaveInterpreterDetail(obj) {
        this.booking = {...this.booking, ...obj}
      },
      getSpecialistFullNameUpper() {
        return utilities.getSpecialistFullNameUpper(this.booking.Specialist)
      },
      openInterpreterDetail() {
        if(this.booking.Status.StatusID === 6) return
        this.$set(this.$refs.interpreterModal.curItem, 'InterpreterName', _.cloneDeep(this.booking.InterpreterName))
        this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCompanyName', _.cloneDeep(this.booking.InterpreterCompanyName))
        this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactNumber', _.cloneDeep(this.booking.InterpreterContactNumber))
        this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactEmail', _.cloneDeep(this.booking.InterpreterContactEmail))
        this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCost', _.cloneDeep(this.booking.InterpreterCost))
        this.$refs.interpreterModal.visible = true
      },
      getInterpreterDetail() {
        let str = ''
        if(this.booking.InterpreterName) {
          str += '<b>N: </b>' + this.booking.InterpreterName + '&nbsp'
        }
        if(this.booking.InterpreterCompanyName) {
          str += '<b>C: </b>' + this.booking.InterpreterCompanyName + '&nbsp'
        }
        if(this.booking.InterpreterContactNumber) {
          str += '<b>P: </b>' + this.booking.InterpreterContactNumber + '&nbsp'
        }
        if(this.booking.InterpreterContactEmail) {
          str += '<b>E: </b>' + this.booking.InterpreterContactEmail + '&nbsp'
        }
        if(this.booking.InterpreterCost) {
          str += '<b>Cost: </b>' + this.booking.InterpreterCost + '&nbsp'
        }
        if(str === '') {
          str+= '<span style="color: #D5D5D5">Click to Add Detail</span'
        }
        return str
      },
      getSurrogateDetail() {
        let str = ''
        if(this.booking.SurrogateAssessorName) {
          str += '<b>N: </b>' + this.booking.SurrogateAssessorName + '&nbsp'
        }
        if(this.booking.SurrogateAssessorCompanyName) {
          str += '<b>C: </b>' + this.booking.SurrogateAssessorCompanyName + '&nbsp'
        }
        if(this.booking.SurrogateAssessorContactNumber) {
          str += '<b>P: </b>' + this.booking.SurrogateAssessorContactNumber + '&nbsp'
        }
        if(this.booking.SurrogateAssessorContactEmail) {
          str += '<b>E: </b>' + this.booking.SurrogateAssessorContactEmail + '&nbsp'
        }
        if(this.booking.SurrogateAssessorCost) {
          str += '<b>Cost: </b>' + this.booking.SurrogateAssessorCost + '&nbsp'
        }
        if(str === '') {
          str+= '<span style="color: #D5D5D5">Click to Add Detail</span'
        }
        return str
      },
      openSurrogateDetail() {
        if(this.booking.Status.StatusID === 6) return
        this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorName',  _.cloneDeep(this.booking.SurrogateAssessorName))
        this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorCompanyName',  _.cloneDeep(this.booking.SurrogateAssessorCompanyName))
        this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorContactNumber',  _.cloneDeep(this.booking.SurrogateAssessorContactNumber))
        this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorContactEmail',  _.cloneDeep(this.booking.SurrogateAssessorContactEmail))
        this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorCost',  _.cloneDeep(this.booking.SurrogateAssessorCost))
        this.$refs.SurrogateModal.visible = true
      },
      handleAllSelect(e) {
        this.booking.bookingFiles.forEach(item => {
          item.checked = e
        })
        this.$forceUpdate()
      },
      onChangeSelectFile(e, file) {
        file.checked = e
        this.$forceUpdate()
      },
      openTimeModal(note, index) {
        if(note) {
          this.currentReply = {note: note, index: index}
          console.log(this.currentReply)
        } else {
          this.currentReply = null
        }
        this.noteDialogVisible = true
      },
      closeModal() {
        this.requestNotes = ''
        this.noteDialogVisible = false
      },
      async submitForm() {
        const param = {
          BookingID: this.booking.BookingID,
          NoteDateTime: window.moment().format('YYYY-MM-DD HH:mm:ss'),
          Note: this.requestNotes,
          Category: this.currentReply ? 'Reply' : 'Request',
          RequestID: this.currentReply?.note?.SpecialistRequestNoteID
        }
        await this.$store.dispatch('loading/setLoadComponent', true)
        const result = await utilities.postSpecialistNote(param)
        if(result) {
          this.closeModal()
          await this.getSpecialistNotes()
        }
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      onChangeEditing(file) {
        this.booking.bookingFiles.forEach(item => {
          item.editing = false
        })
        this.newFileName = file.FileName
        file.editing = true
        this.$forceUpdate()
      },
      async onSaveEditing(file, index) {
        file.editing = false
        await this.updateFileType(file.BookingFileID, index, true)
      },
      onCancelEditing(file) {
        file.editing = false
        this.newFileName = ''
      },
      async showVersionModal(file) {
        this.$store.dispatch('loading/setLoadComponent', true)
        this.versionList = await utilities.getBookingFileVersion(file.BookingFileID,{
          PageNum: 1,
          PageSize: 999
        })
        this.currentFile = file
        this.versionVisible = true
        this.$store.dispatch('loading/setLoadComponent', false)
      },
      showEmailBody(item) {
        let obj = item.LogDetails
        if(item.CommuType === 2) {
          obj = obj.replace(/\n/g,'<br>')
          obj = obj.replace(/\\n/g,'<br>')
        }
        let preFill = ''
        if(item.Attachments && item.Attachments.length > 0 && item.Attachments[0].FileName) {
          preFill = '<b>Attachments: </b>'
          preFill += item.Attachments.map(item => item.FileName).join(', ')
        }
        this.$alert(preFill + obj, 'Email /SMS Content', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'OK',
          customClass: 'w-75 p-4 alert-msg-custom'
        });
      },
      getDate(date) {
        return utilities.formatDate(date, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssssss")
      },
      sortParam(param = 7) {
        this.listParam.SortFlag = param
        switch (param) {
          case 1:
            this.booking.bookingFiles.sort((a, b) => {
              return (b.FileTypeName >= a.FileTypeName) ? 1 : -1
            })
            break;
          case 2:
            this.booking.bookingFiles.sort((a, b) => {
              return (a.FileTypeName >= b.FileTypeName) ? 1 : -1
            })
            break;
          case 3:
            this.booking.bookingFiles.sort((a, b) => {
              return (b.FileName >= a.FileName) ? 1 : -1
            })
            break;
          case 4:
            this.booking.bookingFiles.sort((a, b) => {
              return (a.FileName >= b.FileName) ? 1 : -1
            })
            break;
          case 5:
            this.booking.bookingFiles.sort((a, b) => {
              return (b.UserName >= a.UserName) ? 1 : -1
            })
            break;
          case 6:
            this.booking.bookingFiles.sort((a, b) => {
              return (a.UserName >= b.UserName) ? 1: -1
            })
            break;
          case 7:
            this.booking.bookingFiles.sort((a, b) => {
              return Date.parse(b.DateUploaded) - Date.parse(a.DateUploaded)
            })
            break;
          case 8:
            this.booking.bookingFiles.sort((a, b) => {
              return Date.parse(a.DateUploaded) - Date.parse(b.DateUploaded)
            })
            break;
          case 9:
            this.booking.bookingFiles.sort((a, b) => {
              return b.FileStatus - a.FileStatus
            })
            break;
          case 10:
            this.booking.bookingFiles.sort((a, b) => {
              return a.FileStatus - b.FileStatus
            })
            break;
        }
      },
      async bookingCancel() {
        this.successMessage = 'The booking has now been cancelled.'
        utilities.showAlert(".alert-success")
        await this.loadBooking()
      },

      tapCancel() {
        this.$refs.cancelBookingModal.handleModal()
      },
      async getSpecialistNotes() {
        let bookingId = this.$route.query !== undefined && this.$route.query.id !== undefined ? this.$route.query.id : ''
        const result = await utilities.getSpecialistNote({PageNum:1, PageSize: 10, BookingID: bookingId})
        let arr = result.filter(item => !item.RequestID)
        result.forEach(item => {
          if(item.RequestID) {
            let obj = arr.find(a => a.SpecialistRequestNoteID === item.RequestID)
            if(obj) {
              if(!obj.children) {
                obj.children = [item]
              } else {
                obj.children.push(item)
              }
            }
          }
        })
        this.notesList = arr
      },
      getOriginalBooking() {
        if (!this.isUpdated) {
          this.originalBooking = _.cloneDeep(this.booking)
          this.originalOtherBodyAreaTags = _.cloneDeep(this.otherBodyAreaTags)
          this.originalPersonConditionTags = _.cloneDeep(this.personConditionTags)
          this.originalBookingDate = this.bookingDate
          this.originalBookingTime = this.bookingTime
        }
      },

      checkBookingObjectisUpdated() {
        if (_.isEqual(this.originalBooking, this.booking)) {
          this.isUpdated = false
        } else {
          this.isUpdated = true
        }
      },

      setDefaultStatus() {
        this.isLolChanged = false
        this.isBrirgChanged = false
        this.isAdditionalChanged = false
        this.isPaperworkChanged = false
        this.isChangedAttendance = false
        this.isChangedConsent = false
      },

      async tapSupplementaryService() {

        const bookingParams = {
          AccidentDate: this.booking.AccidentDate,
          OverPeriodofTime: this.booking.OverPeriodofTime,
          ClaimTypeID: this.booking.ClaimTypeID,
          ClientReference: this.booking.ClientReference,
          IncidentState: this.booking.IncidentState,
          id: this.booking.SpecialistID,
          serviceTypes: [8, 18],
          typeId: 8,
          waitlisted: false,
          OnBehalfOf: this.booking.OnBehalfOf,
          bodyAreaTags: this.booking.BodyAreas,
          otherBodyAreaTags: this.otherBodyAreaTags,
          PersonConditions: this.booking.PersonConditions,
          endDate: window.moment().format('YYYY-MM-DD'),
          locationId: this.booking?.Location?.LocationID || null,
          locationName: this.booking?.Location?.LocationName || null,
          bookingDate: '',
          bookingTime: '',
          bookingEndTime: '',
          caseId: this.booking.CaseID,
          bookingId: this.booking.BookingID,
          availabilityId: '',
          // delivery methods contains virtual
          deliveryMethods: null,
          regionId: this.booking.Location?.RegionID || null,
          isSingleId: false,
          isFromSpecialist: false,
          isSupplementary: true,
          originalClientContacts: this.listContact,
          ClientContactID: this.booking.ClientContactID,
          defaultDeliveryMethod: null,
          claimantFirstName: this.booking.Case.ClaimantFirstName.trim(),
          claimantSurname: this.booking.Case.ClaimantSurname.trim(),
          DateofBirth: this.booking.Case.DateofBirth,
          clientId: this.booking.Case.ClientID,
          caseOwner: this.booking.ClientContactID,
          ClientName: decodeURIComponent(this.booking.Case.Client.ClientName + ' - ' + this.booking.Case.Client.BranchName)
        }
        await this.$store.dispatch("booking/setBookingObject", bookingParams)
        this.$router.push({
          name: 'admin-create-new-booking'
        })
      },
      toEditPage() {
        const routeData = this.$router.resolve({ path: '/admin-manage-availability', query: { id: this.booking.SpecialistID } })
        window.open(routeData.href, '_blank')
      },

      openDigram() {
        if(this.booking.Status.StatusID === 6) return
        this.openBodyDiagram()
      },

      openBodyDiagram() {
        if(this.booking.Status.StatusID === 6) return
        this.$refs.addBodyDiagramModal.handleModal()
        this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
        this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
        this.$refs.addBodyDiagramModal.deleteItems = []
        this.$refs.addBodyDiagramModal.handleClick()
      },

      setBodyArea(newBodyTags) {

        this.bodyAreaTags = newBodyTags
        this.booking.BodyAreas = newBodyTags.map(item => {
          return {
            BodyAreaID: item.value,
            BodyArea: item.text
          }
        })
      },

      deleteBodyArea(e) {
        if(this.booking.Status.StatusID === 6) return
        this.openDigram()
      },

      async deletePersonCondition(obj) {
        if(this.booking.Status.StatusID === 6) return
        this.deletedConditionTags.push(obj.tag)
        this.personConditionTags.splice(obj.index, 1);
        this.booking.PersonConditions = this.personConditionTags

      },

      changePaperworkDue() {
        setTimeout(() => {
          this.isValidAccidentDate = this.validateAccidentDate()
        }, 200)
      },

      clearPaperworkDue() {
        if(this.booking.Status.StatusID === 6) return
        this.booking.PaperworkDue = ''
      },

      changeOverTime() {
        if(this.booking.OverPeriodofTime) {
          this.booking.OverPeriodofTime = 0
        } else {
          this.booking.OverPeriodofTime = 1
        }
        if (this.booking.OverPeriodofTime) {
          this.booking.AccidentDate = ''
        } else {
          this.booking.AccidentDate = this.originalBooking.AccidentDate
        }
        this.isValidAccidentDate = this.validateAccidentDate()
      },
      selectAccientDate() {
        this.booking.OverPeriodofTime = 0
      },

      updateConditions(newTags) {
        // if(this.$refs.conditions.newTag.length == 0) newTags.pop() //This one commented commitID-17666983
        this.personConditionTags = newTags
        this.booking.PersonConditions = this.personConditionTags
      },

      updateOtherBodyArea(newTags) {
        this.otherBodyAreaTags = newTags
        this.booking.BodyAreaOther = this.otherBodyAreaTags
      },

      validateAccidentDate() {
        if ($(".accient-date input").val().length > 0) {
          if((this.singleCase.accidentDate == '' || !moment($(".accient-date input").val(), "DD/MM/YYYY").isValid()) && !this.overTime) {
            return false
          }
        }
        return true
      },

      filterReportTo(text) {
        this.listClients = this.originalClientContacts.filter((item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1);
      },

      selectedBillTo(item) {
        if(!item) {
          this.booking.billTo = ""
          this.showBillToEmail = false
          return
        }
        if (item === 'Other') {
          this.booking.BillTo = ""
          this.showBillToEmail = true
        } else {
          this.booking.BillTo = item
          this.showBillToEmail = false
        }
      },

      selectedSendTo(item) {
        if(!item) {
          this.booking.ReportTo = ""
          this.showSendReportToOther = false
          return
        }
        if (item === 'Other') {
          this.booking.ReportTo = ""
          this.showSendReportToOther = true
        } else {
          this.showSendReportToOther = false
          this.booking.ReportTo = item
        }
      },

      updateBookingLog(e) {
        this.getTimelineData(e.target.value)
      },
      changeAccientDate() {
        setTimeout(() => {
          this.isValidPaperworkDue = this.validPaperworkDue()
        }, 200)
      },
      validPaperworkDue() {
        if ($(".paperwork-due input").val() != undefined && $(".paperwork-due input").val().length > 0) {
          if((this.booking.PaperworkDue != '' && !moment($(".paperwork-due input").val(), "DD/MM/YYYY").isValid()) && !this.overTime) {
            return false
          }
        }
        return true
      },

      checkBookingType() {
        this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.booking.BookingTypeID)
      },

      changeBookingType() {
        this.checkBookingType()
        this.booking.BookingType.BookingTypeName = this.bookingTypes.find((x) => x.id == this.booking.BookingTypeID).name
        this.booking.BookingType.BookingTypeID =  this.booking.BookingTypeID
        if (this.booking.BookingType.BookingTypeName === "Supplementary by Video" || this.booking.BookingType.BookingTypeName === "Medical Negligence Request" || this.booking.BookingType.BookingTypeName === "Supplementary" || this.booking.BookingType.BookingTypeName === "File Review") {
          this.isBookingDateChanged = false
          this.isTimeChanged = false
          this.isShowForBooking = false
        } else {
          setTimeout(async () => {
            var date = moment(this.bookingDate, "YYYY-MM-DD").format('YYYY-MM-DD')
            if(this.originalBookingTime != "") {
              this.bookingTime = this.originalBookingTime
              this.booking.BookingDateTime = date + " " +  moment(this.bookingTime, 'hh:mm:ss A').format("HH:mm:ss.ssssss")
            } else {
              this.bookingTime = ""
            }

            this.availableTimes = []
            this.enableButton = true
          }, 200)
          this.isShowForBooking = true
        }
      },

      calculateBookingEndTime() {
        if (this.booking.BookingTypeID === 6 || this.booking.BookingTypeID === 8) {
          return ''
        }

        var startTime = window.moment(this.booking.BookingDateTime, 'YYYY-MM-DD HH:mm:ss').format('hh:mm A')
        var endTime = this.newSlot.find((x) => x.startTime == startTime).endTime

        let acctualEndTime = window.moment(endTime, 'hh:mm A').format('HH:mm:ss')
        this.booking.BookingEndTime = acctualEndTime
        return this.booking.BookingEndTime
      },

      calculateTotalHour() {
        let count = 0
        this.booking.BookingHours.filter(item => item.bookingHoursStatus == 1).forEach(item => {
          count = count + Number(item.numberOfHours)
        })
        this.booking.totalApproveHour = count
        this.$forceUpdate()
      },

      async updateStatus(e, index) {
        this.$store.dispatch('loading/setLoadComponent', true)
        var item = this.booking.BookingHours[index]
        var params = {
          BookingID: this.booking.BookingID,
          BookingHoursStatus: Number(e.target.value),
        }
        await utilities.putAdditionHoursStatus( item.id, params)
        this.booking.billingNotes = await utilities.getBillingNotes(this.booking.BookingID)
        this.setBillingNoteAndAction()
        await this.$store.dispatch('loading/setLoadComponent', false)
        this.calculateTotalHour()
      },

      editNote(index) {
        if(this.booking.Status.StatusID === 6) return
        this.checkBookingObjectisUpdated()
        var item = this.isBilling ? this.billingNoteAndActions[index] : this.bookingNoteAndActions[index]
        if (!item.Deleted) {
          var note = this.isBilling ? this.booking.billingNotes.find(x => x.BillingNoteID === item.id) :  this.booking.bookingNotes.find(x => x.BookingNoteID === item.id)
          if (note.UserID === this.user.id) {
            this.$refs.addNoteModal.isEditClient = true
            this.$refs.addNoteModal.internalOnly = note.InternalOnly
            this.$refs.addNoteModal.editCurrentNote(note, false)
            this.$refs.addNoteModal.handleModal()
          }
        }

      },

      calculateBookingDuration(date, startTime, endTime) {
        if (date && startTime && endTime) {
          var duration = moment.duration(moment(date + " " + endTime, "YYYY-MM-DD hh:mm A").diff(moment(date + " " + startTime, "YYYY-MM-DD hh:mm A")))
          var length = duration.asMinutes()
          if (length) {
            return length
          }
        }
       return ""
      },

      tapCancelConfirmation(states) {
        utilities.hideAlert('.alert-warning-confirm')
      },

      // List push
      toggleBoxDisplay() {
        if ($('.case-container>.box-body').is(':visible')) {
          $('.case-container>.box-body').fadeOut()
        } else {
          $('.case-container>.box-body').fadeIn()
        }
      },
      getCount() {
        let index = 0
        this.notesList.forEach(item => {
          index++;
          if(item.children && item.children.length > 0) {
            item.children.forEach((item1) => {
              index++;
            })
          }
        })
        return index
      },
      openTab(index) {
        if(index === 2) {
          this.isBilling = true
        } else {
          this.isBilling = false
        }
        this.curTab = index
        utilities.openTab(index)
      },
      downloadBtn(fileList) {
        var blogTitle = moment().format('DD/MM/YYYY'); // name for zip
        var zip = new JSZip();
        var promises = [];
        let cache = {};
        for (let item of fileList) {
          if(item.filePath) {
            const promise = this.getImgArrayBuffer(item.filePath).then((data) => {
              zip.file(item.fileName, data, { binary: true });
              cache[item.fileName] = data;
            });
            promises.push(promise);
          }
        }
        Promise.all(promises).then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  blogTitle:自定义文件名
          });
        }).finally(() => {
          this.$store.dispatch('loading/setLoadComponent', false)
          this.$forceUpdate()
        })
      },
      getImgArrayBuffer(url) {
        return new Promise((resolve, reject) => {
          //通过请求获取文件blob格式
          let xmlhttp = new XMLHttpRequest();
          xmlhttp.open("GET", url, true);
          xmlhttp.responseType = "blob";
          xmlhttp.onload = function () {
            if (xmlhttp.status == 200) {
              resolve(xmlhttp.response);
            } else {
              reject(xmlhttp.response);
            }
          };
          xmlhttp.send();
        });
      },
      downloadFiles() {
        let params = {
          fns: [],
          id: this.booking.BookingID,
          filetype: 'bf',
        }
        let fileList = []
        this.booking.bookingFiles.filter(item => item.checked).forEach(item => {
          params.fns.push(item.FileName)
          fileList.push({
            fileName: decodeURIComponent(item.FileName)
          })
        })
        this.$store.dispatch('loading/setLoadComponent', true)
        utilities.getDownloadFilesUrlNew(params).then(res => {
          const arr = res.replaceAll(']', '').replaceAll('[', '').split(',')
          arr.forEach((item, index) => {
            fileList[index].filePath = item
          })
          this.downloadBtn(fileList)

        }).catch(() => {
          this.$store.dispatch('loading/setLoadComponent', false)
        })
      },
      openAddNew() {
        if($(".tab-content").eq(1).is(":visible")) {
          this.openAddFile()
        } else if (this.curTab === 4) {
          this.openTimeModal()
        }
        else this.openAddNoteModal()
      },
      openAddNoteModal() {
        this.checkBookingObjectisUpdated()
        this.$refs.addNoteModal.addNewNote()
        this.$refs.addNoteModal.handleModal()
      },
      openAddFile() {
        $('#assetsFieldHandle').trigger('click')
      },

      deleteVersionFile(file, obj) {
        this.$confirm({
          content: 'Are you sure you want to delete this version?',
          onConfirm: async () => {
            let param = {
            }
            if(obj) {
              param.VersionIds = [file.VersionId]
            } else {
              param.VersionIds = []
            }
            utilities.deleteBookingFileVersion(file.BookingFileID, param).then(async () => {
              this.versionList.splice(obj.$index, 1)
              this.booking.bookingFiles = await utilities.getBookingFileNew({
                BookingID: this.booking.BookingID,
                pageNum: 1,
                pageSize: 999
              })
            })
          }
        })
      },

      async deleteFile(fileId, name, bookingId) {
        await this.$confirm({
          content: 'This will delete this file and its all versions, Are you sure you want to delete it?',
          onConfirm: async () => {
            await this.$store.dispatch('loading/setLoadComponent', true)

            let result = await utilities.deleteBookingFileAllVersion({
              BookingID: bookingId,
              BookingFileID: fileId,
              FileName: name
            })
            if (result) {
              this.versionVisible = false
              let index = this.booking.bookingFiles.findIndex(item => item.BookingFileID === fileId)
              this.booking.bookingFiles.splice(index, 1)
              this.$forceUpdate()
            }
            await this.$store.dispatch('loading/setLoadComponent', false)
          }
        })
      },

      openFileTypeModal() {
        this.$refs.fileTypeModal.reset()
        this.$refs.fileTypeModal.fileTypes = this.fileTypes
        this.$refs.fileTypeModal.handleModal()
      },

      clearFile() {
        $("#assetsFieldHandle").val(null)
      },

      onChange() {
        this.openFileTypeModal()
        this.filelist = [...this.$refs.file.files]

      },

      async uploadFile() {
        if(this.fileTypeId > 0) {
          await this.$store.dispatch('loading/setLoadComponent', true)
          await Promise.all(this.filelist.map(async (x) => {
            if(this.booking.BookingID !== '') {
              try {
                const mimeType = await utilities.getFileMimeType(x, x.type || 'application/octet-stream')
                const result = await utilities.postPreSign({
                  ft: mimeType,
                  fn: x.name,
                  id: this.booking.BookingID,
                  FileStatus: 1,
                  FileTypeID: this.fileTypeId,
                })
                let postData = new FormData()
                for (let key in result.fields) {
                  postData.append(key, result.fields[key]);
                }
                postData.append('file', x)
                const r = await utilities.postImage(result.url, postData)
                if(r) await utilities.postFileRecord(
                  {
                    BookingID: this.booking.BookingID,
                    FileName: x.name,
                    FileStatus: 1,
                    FileTypeID: this.fileTypeId,
                    MimeType: mimeType,
                  }
                )
                this.booking.bookingFiles = await utilities.getBookingFileNew({BookingID: this.booking.BookingID, pageNum: 1, pageSize: 999})
                this.sortParam(this.listParam.SortFlag)
                this.$forceUpdate()
              } catch (error) {
                utilities.showErrorMessage(error.response.data?.message || error.response.data || error)
              }
            }
          }))
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      },
      dragover(event) {
        event.preventDefault()
        // Add some visual fluff to show the user can drop its files
        // if (!event.currentTarget.classList.contains('bg-green-300')) {
        //   event.currentTarget.classList.remove('bg-gray-100')
        //   event.currentTarget.classList.add('bg-green-300')
        // }
        event.currentTarget.classList.add('dark-border-hover')
      },
      dragleave(event) {
        // Clean up
        // event.currentTarget.classList.add('bg-gray-100')
        // event.currentTarget.classList.remove('bg-green-300')
        event.currentTarget.classList.remove('dark-border-hover')
      },
      drop(event) {
        event.preventDefault()
        this.$refs.file.files = event.dataTransfer.files
        this.onChange() // Trigger the onChange event manually
        // Clean up
        event.currentTarget.classList.add('bg-gray-100')
        event.currentTarget.classList.remove('bg-green-300')
        event.currentTarget.classList.remove('dark-border-hover')
      },
      openManageContactModal(e) {
        e.preventDefault()
        e.stopPropagation()
        this.$refs.adminManageContactModal.singleCase = this.singleCase
        this.$refs.adminManageContactModal.booking = this.booking
        this.$refs.adminManageContactModal.handleModal()
      },

      async setBookingNoteAndAction(params) {
        var bookingNoteAndActions = []
        for (var i = 0; i < this.booking.bookingNotes.length; i++) {
          var item = this.booking.bookingNotes[i]
          var noteObject = {
            id: item.BookingNoteID,
            userName: item.UsernameLog,
            deleted: item.Deleted,
            userId: item.UserID,
            dateTime: params && params?.BookingNoteID === item.id ? params?.NoteDateTime : item.NoteDateTime,
            note: item.Note,
            type: 'note',
            internalOnly: item.InternalOnly,
          }
          bookingNoteAndActions.push(noteObject)
        }
        for (var i = 0; i < this.bookingAction.length; i++) {
          var item = this.bookingAction[i]
          var noteObject = {
            id: item.BookingActionRequestID,
            userName: item.RHOUserName,
            userId: item.RequestedBy,
            dateTime: item.DateRequested,
            note: item.RequestedAction,
            type: 'action',
            internalOnly: false,
          }
          bookingNoteAndActions.push(noteObject)
        }
        bookingNoteAndActions.sort((a,b) => {
          return moment(a.dateTime, "YYYY-MM-DD HH:mm:ss.ssssss").isBefore(moment(b.dateTime, "YYYY-MM-DD HH:mm:ss.ssssss")) ? 1 : -1
        })
        this.bookingNoteAndActions = bookingNoteAndActions
      },

      async setBillingNoteAndAction(params) {
        var billingNoteAndActions = []
        for (let i = 0; i < this.booking.billingNotes.length; i++) {
          var item = this.booking.billingNotes[i]
          var noteObject = {
            id: item.BillingNoteID,
            userName: item.Username,
            deleted: item.Deleted,
            userId: item.UserID,
            dateTime: params && params?.BookingNoteID === item.id ? params?.NoteDateTime : item.NoteDateTime,
            note: item.Note,
            type: 'note',
          }
          billingNoteAndActions.push(noteObject)
        }
        billingNoteAndActions.sort((a,b) => {
          return moment(a.dateTime, "YYYY-MM-DD HH:mm:ss.ssssss").isBefore(moment(b.dateTime, "YYYY-MM-DD HH:mm:ss.ssssss")) ? 1 : -1
        })
        this.billingNoteAndActions = billingNoteAndActions
      },

      async getTimelineData(index) {
        this.timelineData = []
        if (index === 0) {
          let x = null
          let length = this.bookingLogs.length > 10 ? 10 : this.bookingLogs.length
          for (let i = 0; i < length; i++) {
            x = this.bookingLogs[i]
            let timeline = {
              id: x.BookingLogID,
              userName: decodeURIComponent(x.Username),
              datetime: utilities.formatDate(x.LogDate, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssssss"),
              body: decodeURIComponent(x.LogDetails.replace(/set to - /g, ' : ')),
            }
            this.timelineData.push(timeline)
          }
        } else {
          var timeline = {}
          this.bookingLogs.map((x) => {
            timeline = {
              id: x.BookingLogID,
              userName: decodeURIComponent(x.Username),
              datetime: utilities.formatDate(x.LogDate, 'DD/MM/YYYY hh:mm A', "YYYY-MM-DD HH:mm:ss.ssssss"),
              body: decodeURIComponent(x.LogDetails.replace(/set to - /g, ' : ')),
            }
            this.timelineData.push(timeline)
          })
        }
      },
      async updateFileType(bookingFileId, index, newName) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        let file = this.booking.bookingFiles[index]
        let params = {
          FileTypeID: file.FileTypeID,
          FileStatus: Number(file.FileStatus),
          BookingID: this.booking.BookingID
        }
        await utilities.putBookingFileDetails(bookingFileId, params)
        this.sortParam(this.listParam.SortFlag)
        this.getOriginalBooking()
        this.$store.dispatch('loading/setLoadComponent', false)
      },
      async finalizeFile(bookingFileId, index) {
        let file = this.booking.bookingFiles[index]
        await this.$store.dispatch('loading/setLoadComponent', true)
        let params = {
          FileStatus: Number(file.FileStatus),
          FileTypeID: file.FileTypeID,
          BookingID: this.booking.BookingID
        }
        await utilities.putBookingFileDetails(bookingFileId, params)
        this.sortParam(this.listParam.SortFlag)
        this.getOriginalBooking()
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      formatDate(date, format = "DD/MM/YYYY", currentFormat = "YYYY-MM-DD") {
        if (date != '' && date != '0000-00-00') {
          return utilities.formatDate(date, format, currentFormat)
        }
        return ''
      },
      toggleCallAfterAppointment() {
        if(this.booking.Status.StatusID === 6) return
        utilities.disposeTooltip()
        this.booking.CallClientAfterAppointment = !this.booking.CallClientAfterAppointment
        utilities.initTooltip()
      },
      toggleCanRingClaimant() {
        if(this.booking.Status.StatusID === 6) return
        utilities.disposeTooltip()
        this.booking.RedHealthMayContactClaimant = !this.booking.RedHealthMayContactClaimant
        utilities.initTooltip()
      },
      toggleAttendance() {
        if(this.booking.Status.StatusID === 6) return
        this.isChangedAttendance = true
        utilities.disposeTooltip()
        if (this.isDate(this.booking.ClaimantConfirmed)) {
          this.booking.ClaimantConfirmed = false
        } else if (this.booking.ClaimantConfirmed == true) {
          this.booking.ClaimantConfirmed = false
        } else {
          this.booking.ClaimantConfirmed = true
        }
        //this.booking.claimantConfirmed = !this.booking.claimantConfirmed
        utilities.initTooltip()
      },
      toggleConsentReceived() {
        if(this.booking.Status.StatusID === 6) return
        this.isChangedConsent = true
        utilities.disposeTooltip()
        if (this.isDate(this.booking.ClaimantConsentReceived)) {
          this.booking.ClaimantConsentReceived = false
        } else if (this.booking.ClaimantConsentReceived == true) {
          this.booking.ClaimantConsentReceived = false
        } else {
          this.booking.ClaimantConsentReceived = true
        }
        //this.booking.claimantConsentReceived = !this.booking.claimantConsentReceived
        utilities.initTooltip()
      },

      toggleVideoLinkTestArranged() {
        if(this.booking.Status.StatusID === 6) return
        if (this.booking.VideoLinkTestStatus == 2) {
          return
        }
        utilities.disposeTooltip()
        if (this.booking.VideoLinkTestStatus == '') {
          this.booking.VideoLinkTestStatus = 1
        } else {
          this.booking.VideoLinkTestStatus = ''
        }
        utilities.initTooltip()
      },
      toggleHasVideo() {
        if(this.booking.Status.StatusID === 6) return
        utilities.disposeTooltip()
        if (this.booking.VideoLinkTestStatus == 2) {
          this.booking.VideoLinkTestStatus = 1
        } else if (true) {
          this.booking.VideoLinkTestStatus = 2
        }
        utilities.initTooltip()
      },
      toggleFeeDeferralRequired() {
        if(this.booking.Status.StatusID === 6) return
        utilities.disposeTooltip()
        this.booking.FeeDeferralRequired = !this.booking.FeeDeferralRequired
        utilities.initTooltip()
      },
      togglePrePaymentRequired() {
        if(this.booking.Status.StatusID === 6) return
        utilities.disposeTooltip()
        this.booking.PrepaymentRequired = !this.booking.PrepaymentRequired
        utilities.initTooltip()
      },
      toggleSpecialistConfirmedHours() {
        if(this.booking.Status.StatusID === 6) return
        utilities.disposeTooltip()
        this.booking.SpecialistConfirmedHours = !this.booking.SpecialistConfirmedHours
        utilities.initTooltip()
      },
      togglelolReceived() {
        if(this.booking.Status.StatusID === 6) return
        this.isLolChanged = true
        if (!this.isDate(this.booking.LOIReceived)) {
          this.booking.LOIReceived = moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.booking.LOIReceived = ''
        }
        this.$forceUpdate()
      },
      togglelolBrirgReceived() {
        if(this.booking.Status.StatusID === 6) return
        this.isBrirgChanged = true
        if (!this.isDate(this.booking.BriefReceived)) {
          this.booking.BriefReceived = window.moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.booking.BriefReceived = ''
        }
        this.$forceUpdate()
      },
      togglelolAdditionalReceived() {
        if(this.booking.Status.StatusID === 6) return
        this.isAdditionalChanged = true
        if (!this.isDate(this.booking.AdditionalPaperworkReceived)) {
          this.booking.AdditionalPaperworkReceived = window.moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.booking.AdditionalPaperworkReceived = ''
        }
        this.$forceUpdate()
      },
      togglelolPaperworkProcessed() {
        if(this.booking.Status.StatusID === 6) return
        this.isPaperworkChanged = true
        if (!this.isDate(this.booking.PaperworkProcessed)) {
          this.booking.PaperworkProcessed = moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.booking.PaperworkProcessed = ''
        }
        this.$forceUpdate()
      },
      openServiceTimeModalPreApproved() {
        if(this.booking.Status.StatusID === 6) return
        this.checkBookingObjectisUpdated()
        this.$refs.adminAddServiceTimeModal.setPreApproved()
        this.$refs.adminAddServiceTimeModal.handleModal()
      },
      openServiceTimeModal() {
        if(this.booking.Status.StatusID === 6) {
          return
        }
        this.checkBookingObjectisUpdated()
        this.roleProps = 'adminAsSpecialist'
        this.$refs.adminAddServiceTimeModal.isPreApproved = false
        this.$refs.adminAddServiceTimeModal.handleModal()
      },
      async deleteNote(item, index) {
        if (item.userId !== this.user.id) {
          return
        }
        utilities.showAlert('.confirmation', false)
        this.deleteId = item.id
        this.deleteIndex = index
      },
      async tapButtonConfirmation(states) {
        utilities.hideAlert('.confirmation')
        if (states) {
          await this.$store.dispatch('loading/setLoadComponent', true)
          let params = {
            id: this.deleteId,
            IsMainEdit: 0,
          }
          if(this.isBilling) {
            const result = await utilities.deleteBillingNoteById(params)
            if (result) {
              let note = this.billingNoteAndActions[this.deleteIndex]
              note.deleted = true
              let deleteNote = this.booking.billingNotes.find((x) => x.BillingNoteID === note.id)
              deleteNote.Deleted = true
            }
            this.$store.dispatch('loading/setLoadComponent', false)
          } else {
            const result = await utilities.deleteBookingNoteById(params)
            if (result) {
              let note = this.bookingNoteAndActions[this.deleteIndex]
              note.deleted = true
              let deleteNote = this.booking.bookingNotes.find((x) => x.BookingNoteID === note.id)
              deleteNote.Deleted = true
            }
            this.$store.dispatch('loading/setLoadComponent', false)
          }
        }
      },

      showWarning() {
        $('html, body').animate({
          scrollTo: $(".button-action").offset()
        }, 500);
        utilities.showAlert('.alert-warning-confirm', false)
      },

      getLocationName(id) {
        if (id && this.booking.Location ) {
          return utilities.getFullLocationUpper(this.booking.Location ).replace(', Australia', "")
        }
        return ''
      },

      getLocationNameWithCoutry(id) {
        if (id && this.booking.Location ) {
          return utilities.getFullLocationUpper(this.booking.Location )
        }
        return ''
      },

      sanitizeAdminBooking() {
        if (this.booking.ClientReference != null) {
          this.booking.ClientReference = String(this.booking.ClientReference).trim()
        }
        const strKeys = ['InterpreterName', 'InterpreterCompanyName', 'InterpreterContactNumber', 'InterpreterContactEmail', 'BillTo', 'ReportTo']
        strKeys.forEach((k) => {
          if (this.booking[k] != null && typeof this.booking[k] === 'string') {
            this.booking[k] = this.booking[k].trim()
          }
        })
      },

      async updateBooking(reason) {

        if ((!this.enableButton || !this.hasChange)) {
          return false
        }

        this.sanitizeAdminBooking()
        this.isValidPaperworkDue = this.validPaperworkDue()

        const blockingErrors = [
          this.clientContactError,
          this.deliveryMethodError,
          this.examineeStateError,
          this.examineeLocationError,
          this.bookingTimeError,
          this.clientReferenceError,
          this.numOfServicesError,
          this.incidentStateError,
        ].filter(Boolean)

        if (blockingErrors.length > 0) {
          this.hasError = true
          this.errorMessage = 'Please correct the errors shown above and try again.'
          utilities.showAlert('.general-alert-danger')
          return false
        }

        if (this.showError || (this.isBookingDateChanged && !this.isTimeChanged)) {
          this.errorMessage = 'The selected date and time is no longer available.'
          this.showWarning()
          this.booking.Status.StatusID = this.originalStatus
          return false
        }

        const paperworkErr = this.paperworkDueError || (!this.validPaperworkDue() ? 'Paperwork due is invalid.' : '')
        const secondaryErrors = [
          paperworkErr,
          this.billToEmailError,
          this.sendReportEmailError,
          this.referralTypeError,
          this.otherBodyAreasError,
          this.additionalHoursReasonError,
          this.bookingNotesContentError,
          this.billingNotesContentError,
        ].filter(Boolean)

        if (secondaryErrors.length > 0) {
          this.hasError = true
          this.errorMessage = 'Please correct the errors shown above and try again.'
          utilities.showAlert('.alert-warning-no-confirm')
          return false
        }

        this.hasError = false
        this.$store.dispatch('loading/setLoadComponent', true)

        var otherBodyArea = ""
        this.otherBodyAreaTags.map((x) => {
          if (otherBodyArea == "") {
            otherBodyArea = x.text
          } else {
            otherBodyArea = otherBodyArea + "," + x.text
          }
        })
        let id = this.$route.query.id != undefined ? this.$route.query.id : ''
        let curBooking = await utilities.getEditBookingById(id)
        curBooking = curBooking
        if(curBooking.UpdatedTime !== this.booking.UpdatedTime) {
          this.$alert('The booking information has been updated by another user. The page will be refreshed, and you can make your change again.', 'Warning', {
            confirmButtonText: 'OK',
            callback: () => {
              window.location.reload()
            }
          });
          this.$store.dispatch('loading/setLoadComponent', false)
          return
        }
        // Create request body
        var params = {
          Booking: {
            PrepaymentRequired: this.booking.PrepaymentRequired ? 1 : 0,
            TPDAssistOnHold: this.booking.TPDAssistOnHold,
            IncidentState: this.booking.IncidentState,
            MAS: this.showMAS ? this.booking.MAS : 0,
            PIC: this.showPIC ? this.booking.PIC : 0,
            ShortReport: this.showSHORT ? this.booking.ShortReport : 0,
            ClaimTypeID: this.booking.ClaimTypeID,
            BookingTypeID: this.booking.BookingTypeID,
            SpecialistID: this.booking.SpecialistID,
            ClientContactID: this.booking.ClientContactID,
            ClientReference: this.booking.ClientReference,
            BookingStatus: this.booking.Status.StatusID.toString(),
            BookingEndTime: this.booking.BookingEndTime ? window.moment(this.booking.BookingEndTime, 'HH:mm:ss').format('HH:mm:ss'): null,
            WillAcceptEarlier: this.booking.WillAcceptEarlier,
            BillTo: this.booking.BillTo,
            FeeDeferralRequired: this.booking.FeeDeferralRequired,
            ReportTo: this.booking.ReportTo,
            LocationID: this.booking.LocationID,
            Reassessment: this.booking.Reassessment ? 1 : 0,
            VideoLink: this.booking.VideoLink,
            VideoLinkTestStatus: (this.booking.DeliveryMethodID === 2 && this.booking.VideoLinkTestStatus) ? this.booking.VideoLinkTestStatus.toString() : '1',
            InterpreterRequired: this.booking.InterpreterRequired,
            SurrogateRequired: this.booking.SurrogateRequired,
            SurrogateAssessorName: this.booking.SurrogateAssessorName === null ? undefined : this.booking.SurrogateAssessorName,
            SurrogateAssessorCompanyName: this.booking.SurrogateAssessorCompanyName === null ? undefined : this.booking.SurrogateAssessorCompanyName,
            SurrogateAssessorContactNumber: this.booking.SurrogateAssessorContactNumber === null ? undefined : this.booking.SurrogateAssessorContactNumber,
            SurrogateAssessorContactEmail: this.booking.SurrogateAssessorContactEmail === null ? undefined : this.booking.SurrogateAssessorContactEmail,
            SurrogateAssessorCost: Number(this.booking.SurrogateAssessorCost) > 0 ? Number(this.booking.SurrogateAssessorCost): null,
            CallClientAfterAppointment: this.booking.CallClientAfterAppointment,
            RedHealthMayContactClaimant: this.booking.RedHealthMayContactClaimant,
            BookingTrackingStatus: this.booking.BookingTrackingStatus,
            SpecialistConfirmedHours: this.booking.SpecialistConfirmedHours,
            AvailabilityID: this.booking.AvailabilityID,
            BodyAreaOther: otherBodyArea,
            OverPeriodofTime: this.booking.OverPeriodofTime ? 1: 0,
            AccidentDate: this.booking.AccidentDate && window.moment(this.booking.AccidentDate).isValid() ? window.moment(this.booking.AccidentDate, "YYYY-MM-DD").format('YYYY-MM-DD') : "",
            OnBehalfOf: this.booking.OnBehalfOf,
            ClaimantStateDuringBooking: this.bookingExamineeStatus && this.bookingExamineeStatus.length > 1 ? this.bookingExamineeStatus[1] : null,
            ClaimantCountryDuringBooking: this.bookingExamineeStatus && this.bookingExamineeStatus.length > 1  ? this.bookingExamineeStatus[0] : null,
            ClaimantTimeZoneDuringBooking: !this.isTPD ? this.timeZoneValue : undefined,
            OriginalBookingID: this.booking.OriginalBookingID,
            OrganizeRequired: this.booking.OrganizeRequired,
          },
          BodyAreas: this.booking.BodyAreas.map(item => {return {BodyAreaID: item.BodyAreaID}}),
          PersonConditions: this.booking.PersonConditions.map(item => {return {PersonConditionID: item}}),
        }

        if (!this.isTPD) {
          params.Booking.InterpreterName = this.booking.InterpreterName ? this.booking.InterpreterName : ""
          params.Booking.InterpreterCompanyName = this.booking.InterpreterCompanyName ? this.booking.InterpreterCompanyName : ""
          params.Booking.InterpreterContactNumber = this.booking.InterpreterContactNumber ? this.booking.InterpreterContactNumber : ""
          params.Booking.InterpreterContactEmail = this.booking.InterpreterContactEmail ? this.booking.InterpreterContactEmail : ""
          params.Booking.InterpreterCost = typeof this.booking.InterpreterCost === 'number' ? Number(this.booking.InterpreterCost) : null
          params.Booking.BookingDateTime = (this.booking.BookingDateTime && this.booking.BookingDateTime.indexOf('0000-00-00') < 0) ? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD HH:mm:ss') : null
        }

        if(utilities.bookingTypeWithDeliveryMethods(this.booking.BookingTypeID)) {
          params.Booking.DeliveryMethodID = this.booking.DeliveryMethodID
        }

        if(params.Booking.DeliveryMethodID === 2) {
          params.Booking.ClaimantLocation = this.booking.ClaimantLocation ? this.booking.ClaimantLocation : ''
        }

        if(reason) {
          params.CancellationReason = reason
        }

        if (this.isTimeChanged) {
          params.Booking.BookingEndTime = this.calculateBookingEndTime()
        }

        this.isUpdated = false
        var callback = async (id) => {
          this.bookingOldDateTime = params.BookingDateTime
          if (id > 0) {
            this.originalStatus = _.cloneDeep(this.booking.Status.StatusID)
            this.successMessage = 'Booking details updated.'
            utilities.showAlert('.alert-success')
            await this.loadBooking()
            this.originalBooking = _.cloneDeep(this.booking)
            this.checkBookingObjectisUpdated()
            this.getOriginalBooking()
            await this.$store.dispatch("setOriginalObject", this.originalBooking)
            await this.$store.dispatch("setNewObject", this.originalBooking)
            if (this.booking.Status.StatusID == 1) {
              this.hideButton = true
            } else {
              this.hideButton = false
            }
            this.setDefaultStatus()
          } else {
            this.errorMessage = 'An error occurred.'
            utilities.showAlert('.alert-warning-no-confirm')
          }

          this.dialogVisible = false
        }
        if(this.bookingWithNoAvailability) {
          params.Booking.BookingEndTime = ""
          params.Booking.BookingDateTime = ""
          params.Booking.LocationID = ""
          params.Booking.AvailabilityID = 0
          if(this.booking.BookingTypeID === 8) {
            params.Booking.SuppFutureDate = window.moment(this.booking.SuppFutureDate).format('YYYY-MM-DD HH:mm:ss')
          }
        }

        let obj = {...params}

        for (let key in obj.Booking) {
          if ((obj.Booking[key] === null || obj.Booking[key] === '' || obj.Booking[key] === undefined) && key.indexOf('Interpreter') < 0 && key.indexOf('SurrogateAssessor') < 0 && key.indexOf('ClaimantLocation') < 0) {
            delete obj.Booking[key];
          }
        }

        if (this.isLolChanged) {
          obj.Booking.LOIReceived = this.booking.LOIReceived == '' ? null : this.booking.LOIReceived
        }
        if (this.isBrirgChanged) {
          obj.Booking.BriefReceived = this.booking.BriefReceived == '' ? null :this.booking.BriefReceived
        }
        if (this.isAdditionalChanged) {
          obj.Booking.AdditionalPaperworkReceived = this.booking.AdditionalPaperworkReceived == '' ? null : this.booking.AdditionalPaperworkReceived
        }
        if (this.isPaperworkChanged) {
          obj.Booking.PaperworkProcessed = this.booking.PaperworkProcessed == '' ? null : this.booking.PaperworkProcessed
        }

        if (this.isChangedAttendance) {
          obj.Booking.ClaimantConfirmed = this.booking.ClaimantConfirmed ? window.moment().format('YYYY-MM-DD HH:mm:ss') : null
        }

        if (this.isChangedConsent) {
          obj.Booking.ClaimantConsentReceived = this.booking.ClaimantConsentReceived ? window.moment().format('YYYY-MM-DD HH:mm:ss') : null
        }

        if(this.booking.DeliveryMethodID === 1) {
          obj.Booking.ClaimantLocation = ''
          obj.Booking.ClaimantStateDuringBooking = ''
          obj.Booking.ClaimantCountryDuringBooking = ''
          obj.Booking.ClaimantTimeZoneDuringBooking = ''
        }

        // phone call
        if(obj.Booking.BookingTypeID === 7) {
          obj.Booking.ShowVideoLinkUrl = this.ShowVideoLinkUrl ? 1 : 0
        }

        await utilities.putBooking(this.booking.BookingID, obj, callback)
        // Process response
        this.getBookingLogs()
        await this.$store.dispatch('loading/setLoadComponent', false)
        return true
      },

      getBookingLogs(data) {
        if (data && data.length > 0) {
          this.bookingLogs = data
          this.bookingLogs.sort((a, b) => {
            return window.moment(a.LogDate, "YYYY-MM-DD HH:mm:ss.ssssss").isAfter(window.moment(b.LogDate, "YYYY-MM-DD HH:mm:ss.ssssss")) ? -1 : 1
          })
        }
      },
      goToCase(caseId) {
        this.$router.push({ path: '/admin-manage-case', query: { id: caseId } }).catch((err) => {})
      },

      goToPurchaseOrder() {
        this.$router.push({ path: '/admin-manage-purchase-order', query: { id: this.booking.BookingID } }).catch((err) => {})
      },

      async openPreEmailModal() {
        var mode = !this.booking.RedHealthMayContactClaimant || !this.client.RedHealthMayContactClaimants ? 'client' : 'claimant'
        var emailOrSmsLocal = this.singleCase.ClaimantMobile !== '' ? 1 : 0
        await this.$store.dispatch('loading/setLoadComponent', true)
        await this.$refs.adminSendEmailModal.getEmailTemplate();
        this.$refs.adminSendEmailModal.getSMSTemplate();
        await this.openEmailModal(mode, emailOrSmsLocal)
      },

      async openEmailModal(mode, emailOrSmsLocal = 0) {
        if(mode === 'claimant' && (!this.booking.RedHealthMayContactClaimant || !this.client.RedHealthMayContactClaimants)) {
          return false
        }

        await this.$store.dispatch('loading/setLoadComponent', true)
        if(!this.booking.RedHealthMayContactClaimant || !this.client.RedHealthMayContactClaimants) {
          this.$refs.adminSendEmailModal.redHealthMayContactClaimant = false
        }

        if (emailOrSmsLocal == 0 && this.emails.claimant == '') {
          mode = 'client'
        }
        this.sendToProps = mode
        this.emailOrSms = emailOrSmsLocal

        this.$refs.adminSendEmailModal.email = utilities.initEmail()
        this.$refs.adminSendEmailModal.sendTo = mode
        this.$refs.adminSendEmailModal.files = []
        this.$refs.adminSendEmailModal.radioChange(mode)
        this.$refs.adminSendEmailModal.emailOrSms = this.emailOrSms
        let list = await utilities.getStandardForms()
        list = list.map(item => {
          return {
            name: item,
            type: 'link',
            checked: false
          }
        })
        this.$refs.adminSendEmailModal.standardFiles = this.booking.bookingFiles.map(item => {return {name: item.FileName, type: 'name', uploadTime: item.DateUploaded, checked: false}}).sort((a, b) => {
          return Date.parse(b.uploadTime) - Date.parse(a.uploadTime)
        }).concat(list)
        this.$refs.adminSendEmailModal.showHideButton()
        this.$refs.adminSendEmailModal.handleModal()
        await this.$store.dispatch('loading/setLoadComponent', false)
      },

      tapHold() {
        if(this.booking.TPDAssistOnHold) {
          this.booking.TPDAssistOnHold = false
        } else {
          this.booking.TPDAssistOnHold = true
        }
      },

      async tapDelete() {
        this.$confirm({
          content: 'Are you sure you want to delete this Booking?',
          onConfirm: async () => {
            this.$store.dispatch('loading/setLoadComponent', true)
            var params = {
              userID: this.user.id,
              userName: this.user.name,
              bookingId: this.booking.BookingID,
              caseId: this.booking.CaseID
            }
            var result = await utilities.deleteBooking(params)
            if (result) {
              window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
            }
            await this.$store.dispatch('loading/setLoadComponent', false)
          }
        })
      },

      requestAction() {
        this.$refs.requestActionModal.handleModal()
      },

      async actionConfirmation(isNew = true) {
        if (isNew) {
          this.successMessage = 'Your update has been saved.'
          utilities.showAlert('.alert-success')
        }
        this.bookingAction = await utilities.getBookingActions(this.booking.BookingID)
        this.setBookingNoteAndAction()
      },
      changeBookingStatusName() {
        this.booking.Status.StatusIDName = this.bookingStatuses.find((x) => x.id === this.booking.Status.StatusID).name
        this.showError = false
      },
      isDate(date) {
        return moment(date, "YYYY-MM-DD").isValid()
      },

      getFileUrl(file) {
        console.log(file)
        const params = {
          fn: file.FileName,
          id: this.booking.BookingID,
          VersionId: file.VersionId,
          filetype: "bf",
        }
        utilities.getDownloadFileUrlNew(params).then(res => {
          let a = document.createElement('a');
          let fileName = file.FileName
          a.target = '_blank'
          a.download = fileName;
          a.href = res
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(res);
          document.body.removeChild(a);
        })
      },
      // async setImageUrl() {
      //   var temp = this.booking.bookingFiles
      //   if (temp == undefined) {
      //     return
      //   }
      //   await Promise.all(temp.map(async(x) =>{
      //     if (x.fileName != '') {
      //       var params = {
      //         uploadtype: "bf",
      //         filename: x.fileName,
      //         id: this.booking.BookingID
      //       }
      //       x.fileUrl = await utilities.getFileUrl(params)
      //     }
      //   }))
      //   this.booking.bookingFiles = temp
      //   this.fileKey +=1
      // },
      sendSuccess() {
        utilities.getCommonLogs(this.$route.query.id).then(res => {
          this.commonLogs = res.data
          this.commonsCount = res.total
        })
      },

      async loadBooking() {
        const bookingId = this.$route.query.id !== undefined ? this.$route.query.id : ''
        this.getSpecialistNotes()
        const apiArr = [utilities.getEditBookingById(bookingId), utilities.getClients(), utilities.getCommonLogs(this.$route.query.id), utilities.getBookingFileNew({BookingID: bookingId, pageNum: 1, pageSize: 999}), utilities.getSpecialists(), utilities.getBookingTypes(), utilities.getBookingNotes({BookingID: bookingId, pageNum: 1, pageSize: 999}), utilities.getBillingNotes(bookingId), utilities.getBookingLogsById(bookingId), utilities.getBodyArea(), utilities.getClaimTypes(), utilities.getPersonConditions(), utilities.getBookingHours({BookingID:this.$route.query.id}), utilities.getStateCodes()]
        const res = await Promise.all(apiArr)
        let bookingData = res[0]
        for (const key in bookingData) {
          if (typeof bookingData[key] === 'string') {
            bookingData[key] = decodeURIComponent(bookingData[key]);
          }
        }
        this.clients = res[1]
        this.commonLogs = res[2].data
        this.commonsCount = res[2].total
        let allBookingTypes = res[5]
        let bodyAreas = res[9]
        this.claimTypes = res[10]
        //call booking step function API.

        if(bookingId != '') {
          this.booking = bookingData
          this.booking.ClientContactID = bookingData.ClientContactID ? bookingData.ClientContactID : null

          this.showMAS = this.booking.MAS > 0
          this.showPIC = this.booking.PIC > 0
          this.showSHORT = this.booking.ShortReport > 0

          if(this.isTPD && !this.booking.BookingDateTime) {
            this.booking.BookingDateTime = '0000-00-00'
          }

          this.ShowVideoLinkUrl = !!this.booking.ShowVideoLinkUrl
          this.booking.SuppFutureDate = bookingData.SuppFutureDate ? moment.utc(bookingData.SuppFutureDate).format('YYYY-MM-DD HH:mm'): null
          this.timeZoneValue = this.booking.ClaimantTimeZoneDuringBooking
          this.bookingExamineeStatus = [this.booking.ClaimantCountryDuringBooking, this.booking.ClaimantStateDuringBooking]
          this.oldExamineeStatus = this.bookingExamineeStatus.concat()
          /*  When a booking status is changed to Cancelled or Fail to Attend, within
          48 hours of the scheduled appointment date/time, add a new button on the
          cancelled booking, called“Re-Book Appointment”
          */

          const timeStart = window.moment(this.booking.CancellationDate, "YYYY-MM-DD HH:mm:ss.ssssss").endOf('day').businessAdd(2)
          const timeEnd = window.moment(this.booking.CancellationDate, "YYYY-MM-DD HH:mm:ss.ssssss").endOf('day').businessAdd(14)
          const statusChangeTimeEnd = window.moment(this.booking.UpdatedTime, "YYYY-MM-DD HH:mm:ss.ssssss").endOf('day').businessAdd(14)


          if(this.booking.BookingStatus === '6' && window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").isSameOrAfter(window.moment(this.booking.CancellationDate, "YYYY-MM-DD HH:mm:ss.ssssss")) && window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").isSameOrBefore(timeStart) && timeEnd.isSameOrAfter(window.moment()) && this.booking.Case.Client.RedRescheduleEnabled) {
            this.showRedRescheduleBtn = true
          }
          if( this.booking.BookingStatus === '7' && this.booking.Case.Client.RedRescheduleEnabled && statusChangeTimeEnd.isSameOrAfter(window.moment())) {
            this.showRedRescheduleBtn = true
          }

          this.booking.OnBehalfOf = decodeURIComponent(this.booking.OnBehalfOf)
          this.booking.bookingNotes = res[6]
          this.booking.billingNotes = res[7]
          this.booking.bookingLogs = res[8]
          this.booking.BookingHours = res[12]
          this.calculateTotalHour()
          this.states = res[13]
          this.booking.bookingFiles = res[3]
          this.curSpecialty = this.booking.Specialist.Qualifications ? this.booking.Specialist.Qualifications.map(item => item.QualificationName).join(', ') : ''
          this.sortParam()

          this.specialists = _.cloneDeep(res[4])
          this.fileTypes = await utilities.getFileTypes()
          const contacts = await utilities.choiceGetContact(this.booking.Case.Client.ClientID)
          this.reugularContacts = contacts
          this.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(contacts))
          this.listContact = this.originalClientContacts
          this.contacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(contacts, false))
          this.bookingWithNoAvailability = !utilities.bookingTypeWithAvailability(this.booking.BookingTypeID)
          //If claimantConfirmed. then save claimantConfirmed as bool value.
          if (this.isDate(this.booking.ClaimantConfirmed)) {
            this.booking.ClaimantConfirmed = true
          }
          if (this.isDate(this.booking.ClaimantConsentReceived)) {
            this.booking.ClaimantConsentReceived = true
          }

          if (!this.booking) {
            this.showContent = false
            return
          }

          if (this.booking.Status.StatusID === 1) {
            this.hideButton = true
          }

          if (!utilities.bookingTypeWithAvailability(this.booking.BookingType.BookingTypeID)) {
            this.isShowForBooking = false
          }

          // 4915 - Set OTFCE is false as default and disable booking types for FCE Lite and FCE Lite by Video
          if (this.booking.BookingType.BookingTypeName === 'FCE Lite' || this.booking.BookingType.BookingTypeName === 'FCE Lite by Video') {
            this.isDisabled = true
            this.hidePurchaseOrderButton = true
          } else {
            this.isDisabled = false
            this.hidePurchaseOrderButton = false
          }

          this.getBookingLogs(this.booking.bookingLogs)
          await this.getTimelineData(0)


          this.originalStatus = _.cloneDeep(this.booking.Status.StatusID)

          if (this.booking.VideoLink) {
            this.showSurrogate = false
          }

          this.bookingDate = this.booking.BookingDateTime ? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD') : null
          this.bookingTime = this.booking.BookingDateTime? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('hh:mm A') : ""
          this.bookingOldDateTime = this.booking.BookingDateTime? _.cloneDeep(window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD HH:mm:ss')) : ""

          this.client = bookingData.Case.Client
          Object.keys(bookingData.Case).forEach(item => {
            if(typeof bookingData.Case[item] === 'string') {
              bookingData.Case[item] = decodeURIComponent(bookingData.Case[item])
            }
          })
          this.singleCase = bookingData.Case
          this.clientContacts = contacts

          //set send report to data
          if (bookingData.ReportTo) {
            let sendReportTo = this.listContact.find((x) => x.value.toLowerCase() === bookingData.ReportTo.toLowerCase())
            if (sendReportTo === undefined && this.booking.ReportTo) {
              sendReportTo = {
                id: -1,
                name: "Other",
                value: 'Other'
              }
              this.sendToModel = 'Other'
              this.showSendReportToOther = true
            } else {
              this.sendToModel = sendReportTo.value
            }
          }

          //setBill to email
          if (bookingData.BillTo) {
            var billTo = this.listContact.find((x) => x.value.toLowerCase() === bookingData.BillTo.toLowerCase())
            if (billTo === undefined && this.booking.BillTo) {
              billTo = {
                id: -1,
                name: "Other",
                value: 'Other'
              }
              this.billToModel = 'Other'
              this.showBillToEmail = true
            } else {
              this.billToModel = billTo.value
            }
          }

          utilities.getBookingActions(this.booking.BookingID).then(res => {
            this.bookingAction = res
          })
          this.setBookingNoteAndAction()
          this.setBillingNoteAndAction()


          if (this.booking.BodyAreas.length > 0) {
            // this.addedBodyArea = _.cloneDeep(this.booking.bodyAreas)
            this.bodyAreaTags = utilities.getAutoCompleteBodyAreaTags(this.booking.BodyAreas)
          }

          if (this.booking.BodyAreaOther && this.booking.BodyAreaOther.length > 0) {
            var items = this.booking.BodyAreaOther.split(',');
            this.otherBodyAreaTags = utilities.getAutoCompleteOtherBodyAreaTags(items)
          }

          this.bodyAreas = utilities.getAutoCompleteBodyAreaTags(bodyAreas)

          let personConditions = res[11]
          this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)
          if (this.booking.PersonConditions.length > 0) {
            this.booking.PersonConditions = this.booking.PersonConditions.map(item => item.PersonConditionID)
          }


          let specialist = this.specialists.find((x) => x.id === this.booking.SpecialistID)
          let item = specialist.qualifications.find((q) => q.qualificationId == 43)
          if (item || this.booking.BookingTypeID === 4 || this.booking.BookingTypeID === 9) {
            this.showSurrogate = false
          }

          this.emails = {
            specialist: this.booking.Specialist.EmailAddress,
            client: this.booking.ClientContact && this.booking.ClientContact.NotificationEmailAddress ? this.booking.ClientContact.NotificationEmailAddress : "",
            claimant: this.booking.Case.ClaimantEmail,
          }
          if(this.emails.client === "" && this.booking.ClientContact && this.booking.ClientContact.EmailAddress) {
            this.emails.client = this.booking.ClientContact.EmailAddress
          }
          this.phones = {
            specialist: this.booking.Specialist.Mobile,
            client: this.booking.ClientContact ? this.booking.ClientContact.Mobile : "",
            claimant: this.booking.Case.ClaimantMobile,
            rhadmin: this.user.phone
          }
          this.names = {
            specialist: utilities.getSpecialistFullNameUpper(this.booking.Specialist),
            // client: this.getCaseOwnerName,
            claimant: decodeURIComponent(this.booking.Case.ClaimantFullName)
          }
          this.specialist = specialist
          this.statusKey += 1

          this.disableBookingType = false

          if(this.booking.Availability) {
            this.bookingTypes = allBookingTypes.filter(item => this.booking.Availability?.ServiceTypes.find(i => i.BookingTypeID === item.id))
          } else {
            this.disableBookingType = true
            this.bookingTypes = allBookingTypes
          }

          this.locations = bookingData.locations
          if (this.booking.Status.StatusID == 16) {
            this.bookingTime = ""
          }

          //show hide SupplementaryService button depend on the service type
          if (utilities.bookingTypeWithAvailability(this.booking.BookingTypeID) || this.booking.BookingTypeID === 6 || this.booking.BookingTypeID === 8) {
            this.showSupplementaryService = true
          }
        }
        this.checkBookingType()
        await this.$store.dispatch("setOriginalObject", this.booking)
        await this.$store.dispatch("setNewObject", this.booking)
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      async loadData() {
        this.paperworkStatuses = utilities.getPaperworkStatuses()
      },
    },
    async beforeMount() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      await this.loadData()
      await this.loadBooking()
      this.getOriginalBooking()
      this.loaded = true
      this.openTab(0)
      this.isValidPaperworkDue = this.validPaperworkDue()
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
  }
</script>

<style scoped>
.content {
  height: calc(100vh - 76px);
  overflow-y: hidden;
}
.content-sub-content {
  height: 100%;
  overflow-y: auto;
}
.default-checkbox.tick {
  margin-left: 20px;
  margin-right: 20px;
  height: 40px;
}
::v-deep .el-input-number .el-input__inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
  ::v-deep .cancel-dialog .el-dialog__headerbtn .el-dialog__close {
      font-size: 24px;
      font-weight: bold;
    }
  ::v-deep .el-dialog__headerbtn:hover .el-dialog__close{
    color: #909399;
  }
  .cancel-dialog .v-btn {
    min-width: 120px !important;
    min-height: 39px;
    border-radius: 5px;
    text-transform: capitalize;
    background-color: #525252;
    box-shadow: none;
  }
  .cancel-dialog .white-button {
    background-color: unset !important;
    color: #3FA2F7;
  }

</style>
